$(".page-width .uploadPropTipDiy").remove();
let demensionNeed=false;
let undoArr = [];//Revoke array
let singleShade, twoSidedShade;//Single and double-sided mask
let windowHV = 1; //Screen mode defaults to 1 for PCs and 2 for mobile
if($(window).width()<750){
    windowHV=2;
}
let oneOrTwoSide=0;//Single sided selector defaults to 0
let productsType="cup";//Product type
let productSize="8";//Product model
let materialProduct;
let fileUserIdA,fileUserIdB;
let allCanvasArr=[];
let currentNum=0;
let fullAll=false;
let inchMM = 25.4;//1in==25.4mm
let dpi=300;
let nameType;
let aspectRatio;//size width/height
let sizeArrWGH;
let baseDiyPath=window.locaUrlDiy + "/diyWeb/assets/resource/imgs/normal/";
let minFontSize=5;
let maxFontSize=100;
let initFontSize=8;
isShowisInstructionsTipFun=true
/***************Data preparation start***********************/
//load font
$.ajax({
    async: true,
    url: window.locaUrlDiy + "/diyWeb/diy/findAllFont.do",
    cache: true,
    type: "post",
    success: function (fontData) {
        var that = this;
        if (fontData.success) {
            let fontNames = new Array();
            $("#font-type-select .type-select .selectDrop").empty();
            $.each(fontData.userData, function (index, item) {
                if (index < 5) fontNames.push(fontData.userData[index].fontname);
                let html =
                    '<li fontid="' +
                    item.id +
                    '" fontname="' +
                    item.fontname +
                    '" fontdefaultimage="MXYZ-E30ABE12220C489F8ADC4A39B4FDFF5E.png">' +
                    '<img height="25px" src="https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/' +
                    item.defaultimage +
                    '">' +
                    "</li>";
                $("#font-type-select .type-select .selectDrop").append(html);
            });
            WebFont.load({
                custom: {
                    families: fontNames,
                    urls: [window.locaUrlDiy + "/diyWeb/diy/getFontCss.do"],
                },
                loading: function () {
                    console.log("start load");
                },
                active: function () {
                    if (that.isMaster == false) return;
                },
                inactive: function () {
                    // $('.mainloading').fadeOut();
                },
                fontloading: function (fontFamily, fontDescription) {
                    console.log("font load complete");
                },
                fontactive: function (fontFamily, fontDescription) {
                    console.log("font  render");
                },
                fontinactive: function (fontFamily, fontDescription) {
                    console.log("font load error");
                },
            });
        } else {
            // alert(fontData.message);
        }
    },
    error: function () {},
});
let defulatX=0,defulatY=0,defulatX1=0,defulatY1=0,defulatX2=0,defulatY2=0,defulatW=1,defulatH=1,defulatW1=1,defulatH1=1;
let changeX,changeY,changeX2,changeY2;
let newProduct=["Tabletop Display","vinylbanner","Retractable Banners","Posters","Puzzles","XBanners","Placemats","Flyers"];
// get shade type
let getShadeType=function (maskName) {
    let canvas=allCanvasArr[currentNum].canvas;
    $.ajax({
        async:false,
        url: window.locaUrlDiy + "/diyWeb/diy/findShadeInfoList.do",
        type: "POST",
        data: {
            maskName: maskName
        },
        success: function (res) {
            if (res.success) {
                if (res.userData && res.userData.length > 0) {
                    $.each(res.userData, function (index, item) {
                        //get shade
                        if(windowHV==1){
                            if (item.pagenum == 1) {//same
                                singleShade = baseDiyPath +item.imagepath;
                                if(item.uvpictrueinfor && item.uvpictrueinfor!=""){
                                    let uvpictrueinfor=JSON.parse(item.uvpictrueinfor.replaceAll("'","\""));
                                    defulatX=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                    defulatY=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                    defulatW=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                    defulatH=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                                }
                            } else if (item.pagenum == 2) { //H  no same
                                twoSidedShade = baseDiyPath + item.imagepath;
                                if(item.uvpictrueinfor && item.uvpictrueinfor!=""){
                                    let uvpictrueinfor=JSON.parse(item.uvpictrueinfor.replaceAll("'","\""));
                                    defulatX2=uvpictrueinfor.x2/uvpictrueinfor.imgw;
                                    defulatY2=uvpictrueinfor.y2/uvpictrueinfor.imgh;
                                    defulatX1=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                    defulatY1=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                    defulatW1=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                    defulatH1=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                                }
                            }
                        }else{
                            if (item.pagenum == 3) {//same
                                singleShade = baseDiyPath +item.imagepath;
                                if(item.uvpictrueinfor && item.uvpictrueinfor!=""){
                                    let uvpictrueinfor=JSON.parse(item.uvpictrueinfor.replaceAll("'","\""));
                                    defulatX=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                    defulatY=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                    defulatW=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                    defulatH=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                                }
                            } else if (item.pagenum == 4) { //H  no same
                                twoSidedShade = baseDiyPath + item.imagepath;
                                if(item.uvpictrueinfor && item.uvpictrueinfor!=""){
                                    let uvpictrueinfor=JSON.parse(item.uvpictrueinfor.replaceAll("'","\""));
                                    defulatX2=uvpictrueinfor.x2/uvpictrueinfor.imgw;
                                    defulatY2=uvpictrueinfor.y2/uvpictrueinfor.imgh;
                                    defulatX1=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                    defulatY1=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                    defulatW1=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                    defulatH1=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                                }
                            }
                        }
                        if(productsType=="Planner"){
                            if(windowHV==2){
                                $(".page-change-canvas").css("top","10%");
                            }
                            $(".can-resource.can-resource1").append('<div class="planner-name" style="font-size: 16px;bottom: -30px;position: absolute;"><span>Front Cover</span></div>');
                            if (item.pagenum == 1) {//same
                                singleShade = baseDiyPath +item.imagepath;
                                if(item.uvpictrueinfor && item.uvpictrueinfor!=""){
                                    let uvpictrueinfor=JSON.parse(item.uvpictrueinfor.replaceAll("'","\""));
                                    defulatX=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                    defulatY=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                    defulatW=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                    defulatH=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                                }
                            }
                            if(item.imagepathwhite!=""){
                                let url=baseDiyPath + item.imagepathwhite;
                                let path;
                                if(materialProduct=="spiral"){
                                    //add black spiral
                                    path=baseDiyPath +"MXYZ-A00DFF4EA84D4713ACDE3C9FBD255F13.png";
                                    if(UploadProductType.UploadProductType.spiralColor=="white"){
                                        //white spiral
                                        url=baseDiyPath + item.knifeplatesvg;
                                        path=baseDiyPath +"/MXYZ-D9037FBD41874FE28736B02BECF214BC.png";
                                    }
                                }else if(materialProduct=="soft"){
                                    //MXYZ-3BD335060CA9433DA19A700D8CF9CD80.png soft
                                    path=baseDiyPath +"/MXYZ-3BD335060CA9433DA19A700D8CF9CD80.png";
                                }else if(materialProduct=="hard"){
                                    //MXYZ-0A52AC3732854B4592D40AEC9E797D10.png hard
                                    path=baseDiyPath +"/MXYZ-0A52AC3732854B4592D40AEC9E797D10.png";
                                }
                                $(".can-resource.can-resource1").append('<div class="spiral-img left"><img src="'+path+'"></div>');
                                $(".spiral-img").css("height",($(".canvas-container").height()/($(".can-resource.can-resource1").innerHeight())*100)+"%");
                                let chanW=$(".spiral-img").width()/2;
                                if(materialProduct!="spiral"){
                                    chanW=0;
                                }
                                let number = ($(".can-resource.can-resource1").width()/2-$(".canvas-container").width()/2-chanW)/$(".can-resource.can-resource1").width()*100;
                                $(".spiral-img").css("right","unset");
                                $(".spiral-img").css("left",number+"%");
                                $(".spiral-img").css("transform","rotate(180deg)");
                                imagemodelpath=url;
                                $(".paper-handbag-preview .preview-img").attr("src",url);
                            }
                        }
                    });
                    // draw background and shade
                    if(productsType!="Planner")drawBgAndShade(singleShade);
                    changeX=(defulatX-defulatX1)*canvas.width//defulatW*canvas.width*0.9;
                    changeX2=(defulatX2-defulatX)*canvas.width//defulatW*canvas.width*0.9;
                    changeY=(defulatY-defulatY1)*canvas.height//defulatH*canvas.height*0.62;
                    changeY2=(defulatY2-defulatY)*canvas.height//defulatH*canvas.height*0.62;
                    maxFontSize=parseInt(defulatH*canvas.height/1.16);
                }
            }
        },
        error: function (error) {},
    });
}

//get background style
let getBackGroundFun=function(name) {
    if(isNewType){
        let typeVH;
        if(name.indexOf("HSingle")>-1){
            typeVH="tsingleback";
        }else if(name.indexOf("HTwo")>-1){
            typeVH="tpairback";
        }else if(name.indexOf("VSingle")>-1){
            typeVH="vsingleback";
        }else if(name.indexOf("VTwo")>-1){
            typeVH="vpairback";
        }
        if(typeVH){
            if(nameType != "insulatedCoolerBags"){
                $(".bg-list-items").empty();
            }
            $.each(productGoodsInfor,function (index,item) {
                handlerBg(item,typeVH);
            })
        }
        return;
    }
    let reName=name;
    if(productsType=="bag"){
        if(materialProduct=="whitePaper"){
            reName=reName+"-B";
        }else{
            reName=reName+"-N";
        }
    }
    if(nameType=="groceryBags" || nameType=="ribbonBag"){
        reName=name;
        reName=reName+"-"+materialProduct;
    }

    $.ajax({
        url: window.locaUrlDiy + "/diyWeb/diy/findBackGroundByName.do",
        type: "POST",
        data: {
            name: reName
        },
        success: function (res) {
            if (res.success) {
                if (res.userData && res.userData.length > 0) {
                    $(".bg-list-items").empty();
                    if(productsType=="cup"){
                        $.ajax({
                            url: window.locaUrlDiy + "/diyWeb/diy/findBackGroundByName.do",
                            type: "POST",
                            data: {
                                name: "cup"+productSize+"Model"
                            },
                            success: function (modelObj) {
                                if (modelObj.success) {
                                    if (modelObj.userData && modelObj.userData.length > 0) {//样机预览图
                                        $(".bg-list-items").empty();
                                        for(let j=modelObj.userData.length-1;j>-1;j--){
                                            let modelItem=modelObj.userData[j];
                                            let previewPath;
                                            let bgtemplateid;
                                            for(let i=0;i<res.userData.length;i++){//背景图
                                                let itemP = res.userData[i];
                                                if(productSize==8){
                                                    let modelName=itemP.name.replace("横单","横单样机").replace("竖单","横单样机").replace("横双","横单样机").replace("竖双","横单样机");
                                                    if(modelName==modelItem.name){
                                                        previewPath=itemP.url;
                                                        bgtemplateid = itemP.searchword;
                                                        break;
                                                    }
                                                }else{
                                                    let modelName=itemP.name.replace("横单-大","横单样机-高").replace("竖单-大","横单样机-高").replace("横双-大","横单样机-高").replace("竖双-大","横单样机-高");
                                                    if(modelName==modelItem.name){
                                                        previewPath=itemP.url;
                                                        bgtemplateid = itemP.searchword;
                                                        break;
                                                    }
                                                }
                                            }
                                            if(previewPath){
                                                let imageshowpath=modelItem.url;
                                                if(modelItem.imageshowpath && modelItem.imageshowpath.length>1){
                                                    imageshowpath=modelItem.imageshowpath
                                                }
                                                let modelPath=imagemodelpath;
                                                if(productsType=="cup" && modelPath && modelItem.imagemodelpath && modelItem.imagemodelpath.length>1){
                                                    modelPath=baseDiyPath +modelItem.imagemodelpath;
                                                    let html = '<div class="bg-item" bgtemplateid="'+bgtemplateid+'"><img src="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +imageshowpath +'" osrc="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +previewPath+'" modelPath="'+modelPath+'"></div>';
                                                    $(".bg-list-items").append(html);
                                                }else {
                                                    let html = '<div class="bg-item"><img src="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +imageshowpath +'" osrc="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +previewPath+'"></div>';
                                                    $(".bg-list-items").append(html);
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            error: function (error) {},
                        });
                    }else{
                        $.each(res.userData, function (index, item) {
                            let html =
                                '<div class="bg-item"><img src="' +
                                window.locaUrlDiy +
                                "/diyWeb/assets/resource/imgs/small/" +
                                item.url +
                                '"></div>';
                            $(".bg-list-items").append(html);
                        });
                    }
                }
            }
        },
        error: function (error) {},
    });
}

//Get preview image
let imagemodelpath;
let getPreviewImageFun=function(name) {
    let reName=name;
    if(productsType=="bag"){
        if(materialProduct=="whitePaper"){
            reName=reName+"-B";
        }else{
            reName=reName+"-N";
        }
        if(nameType == "groceryBags" || nameType=="ribbonBag"){
            reName = name;
            reName=reName+"-"+materialProduct;
        }
    }
    $.ajax({
        url: window.locaUrlDiy + "/diyWeb/diy/findBackGroundByName.do",
        type: "POST",
        data: {
            name: reName
        },
        success: function (res) {
            if (res.success) {
                if (res.userData && res.userData.length > 0) {
                    $.each(res.userData, function (index, item) {
                        let url=baseDiyPath + item.url;
                        if(productsType=="Puzzles"){
                            if(item.width>item.height){
                                puzzPreviewH=url;
                            }else {
                                puzzPreviewV=url;
                            }
                        }else {
                            imagemodelpath=url;
                            $(".paper-handbag-preview .preview-img").attr("src",url);
                        }
                    });
                    if(productsType=="Puzzles"){
                        if($(".show-btn-direct .on").hasClass("v-show")){
                            $(".paper-handbag-preview .preview-img").attr("src",puzzPreviewV);
                            imagemodelpath=puzzPreviewV;
                        }else {
                            $(".paper-handbag-preview .preview-img").attr("src",puzzPreviewH);
                            imagemodelpath=puzzPreviewH;
                        }
                    }
                }
            }
        },
        error: function (error) {},
    });
}

//get product info
let getInitData=function () {
    //Optimization of single-sided style on mobile devices
    // get shade type
    let maskName=productsType+"-"+productSize+"-HWZ";
    if(productsType=="cup"){
        maskName=productsType+"-"+productSize+"angsi-HWZ";
    }else if(productsType=="bag"){
        if(aspectRatio<1){
            if(materialProduct=="whitePaper"){
                maskName=productsType+"-"+"5.8*3.2*8.25A-baika"+"-HWZ";
            }else{
                maskName=productsType+"-"+"5.8*3.2*8.25A-niupi"+"-HWZ";
            }
        }else if(aspectRatio==1){
            if(materialProduct=="whitePaper"){
                maskName=productsType+"-"+"11*6*11E-baika"+"-HWZ";
            }else{
                maskName=productsType+"-"+"11*6*11E-niupi"+"-HWZ";
            }
        }else if(aspectRatio>1){
            if(materialProduct=="whitePaper"){
                maskName=productsType+"-"+"12.6*4.3*10.6F-baika"+"-HWZ";
            }else{
                maskName=productsType+"-"+"12.6*4.3*10.6F-niupi"+"-HWZ";
            }
        };
        if(nameType=="heldBag"){
            maskName="heldBag-"+"3.5*2.17*7A-baika"+"-HWZ";
        }else if(nameType=="toteBag"){
            if(aspectRatio<1){
                if(materialProduct=="whitePaper"){
                    maskName="toteBag-"+"8*4*10A-baika"+"-HWZ";
                }else{
                    maskName="toteBag-"+"8*4*10A-black"+"-HWZ";
                }
            }else if(1<aspectRatio){
                if(materialProduct=="whitePaper"){
                    maskName="toteBag-"+"13.8*5.1*10.2B-baika"+"-HWZ";
                }else{
                    maskName="toteBag-"+"13.8*5.1*10.2B-black"+"-HWZ";
                }
            }
        }else if(nameType=="flatBag"){
            maskName="";
            if(aspectRatio<1){
                maskName=nameType+"-v";
            }else if(1<aspectRatio){
                maskName=nameType+"-h";
            }
            if(materialProduct=="whitePaper"){
                maskName=maskName+"-baika"+"-HWZ";
            }else{
                maskName=maskName+"-niupi"+"-HWZ";
            }
            if(aspectRatio>1){
                $(".paper-handbag-Diy .can-resource").addClass("H");
            }
        }else if(nameType=="ribbonBag"){
            maskName="";
            if(aspectRatio<1){
                maskName=nameType+"-v-";
            }else if(1<aspectRatio){
                maskName=nameType+"-h-";
            }
            maskName=maskName+materialProduct+"-HWZ";
            if(aspectRatio>1){
                $(".paper-handbag-Diy .can-resource").addClass("H");
            }
        }else if(nameType=="groceryBags"){
            maskName="";
            if(productSize == "A"){
                maskName="groceryBags-8*5*10-"+materialProduct+"-HWZ";
            }else if(productSize == "B"){
                maskName="groceryBags-9*6*10-"+materialProduct+"-HWZ";
            }else if(productSize == "C"){
                maskName="groceryBags-10*7*10-"+materialProduct+"-HWZ";
            }else if(productSize == "D"){
                maskName="groceryBags-12*4*15-"+materialProduct+"-HWZ";
            }
        }
    }
    if(productsType=="cup" || productsType=="bag"){
        // get shade type
        getShadeType(maskName);
        //get background style
        if(windowHV==1){
            if(nameType=="toteBag" || nameType=="heldBag" || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags"  || nameType == "insulatedCoolerBags"){
                getBackGroundFun(nameType+productSize+"VSingle");
            }else {
                getBackGroundFun(productsType+productSize+"HSingle");
            }
        }else{
            if(nameType=="toteBag" || nameType=="heldBag"  || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags"  || nameType == "insulatedCoolerBags"){
                getBackGroundFun(nameType+productSize+"VSingle");
            }else {
                getBackGroundFun(productsType+productSize+"VSingle");
            }
        }

        //Get preview image
        if(nameType=="toteBag" || nameType=="heldBag"  || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags"  || nameType == "insulatedCoolerBags"){
            getPreviewImageFun(nameType+productSize+"Preview");
        }else {
            getPreviewImageFun(productsType+productSize+"Preview");
        }
        //defalut no.1
        if(productsType=="bag"){
            if(materialProduct != "whitePaper"){
                setTimeout(function(params) {
                    $('.bg-list-items .bg-item img').eq(0).trigger('click')
                },500);

            }
        }
    }else if(newProduct.indexOf(productsType)>-1 || productsType=="Planner"){
        let canvas=allCanvasArr[currentNum].canvas;
        changeX=(defulatX-defulatX1)*canvas.width//defulatW*canvas.width*0.9;
        changeX2=(defulatX2-defulatX)*canvas.width//defulatW*canvas.width*0.9;
        changeY=(defulatY-defulatY1)*canvas.height//defulatH*canvas.height*0.62;
        changeY2=(defulatY2-defulatY)*canvas.height//defulatH*canvas.height*0.62;
        if(productsType=="vinylbanner"){
            let roWh=canvas.width/canvas.height;
            let typeSize="H";
            if(roWh<=0.8){
                typeSize="V";
            }else if(0.8<roWh && roWh<=1.2){
                typeSize="R";
            }
            getPreviewImageFun("vinlyBannerPreview-"+typeSize);
        }else if(productsType=="Posters"){
            getPreviewImageFun("posterPreview");
        }else if(productsType=="Retractable Banners"){
            getPreviewImageFun("Retractable Banners");
        }else if(productsType=="Tabletop Display"){
            getPreviewImageFun("Tabletop Display");
        }else if(productsType=="Planner"){
            //Loop mounted notebook  8.2*11
            //Hard shell notebook 8.2*11
            //Soft shell notebook 8.2*11
            let maskOrigin="";
            if(materialProduct=="spiral"){
                maskOrigin="Loop mounted notebook ";
            }else if(materialProduct=="soft"){
                maskOrigin="Soft shell notebook ";
            }else if(materialProduct=="hard"){
                maskOrigin="Hard shell notebook ";
            }
            let workAreaArr = $('.newproductselectfirstchildSize').text().replaceAll('"',"").replaceAll(" ","").split("x");
            maskName=maskOrigin+workAreaArr[0]+"*"+workAreaArr[1];
            // get shade type
            getShadeType(maskName);
            updateGuideLineShow(false);
            $(".page-change-canvas li img").attr("src",allCanvasArr[0].canvas.toDataURL());
        }else if(productsType=="Puzzles"){
            getPreviewImageFun("Puzzles-"+$('.newproductselectfirstchildSize').text().split("(")[0].replaceAll(" ","")+"-"+materialProduct);
        }
    }
    handlerDom();
}
let handlerBg=function (item,type) {
    if(productsType=="cup"){
        if(productsType=="cup" && item.prototype && item.hologram){
            let modelPath=baseDiyPath +item.prototype;
            let bgtemplateid=1;
            let html = '<div class="bg-item" bgtemplateid="'+bgtemplateid+'"><img src="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +item.hologram +'" osrc="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +item[type]+'" modelPath="'+modelPath+'"></div>';
            $(".bg-list-items").append(html);
        }else if(item.tsingleback){
            let html = '<div class="bg-item"><img src="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +item.tsingleback +'" osrc="' +window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" +item[type]+'"></div>';
            $(".bg-list-items").append(html);
        }
    }else{
        //if(nameType !="groceryBags" ){
            if(item[type]){
                let html = '<div class="bg-item"><img src="' + window.locaUrlDiy + "/diyWeb/assets/resource/imgs/small/" + item[type]+ '"></div>';
                $(".bg-list-items").append(html);
            }
        //} 
    }
}
let productGoodsInfor;
let newGetDataFun=function (code) {
    let canvas=allCanvasArr[currentNum].canvas;
    //get preview、shade、backGround
    $.ajax({
        async:false,
        url:  'https://diy.racetopprint.com/mcard/hwz/findGoodsInfoByCode.do',
        method: 'post',
        data: {
            "code": code
        },
        success: function (data) {
            data=JSON.parse(data);
            if (data && data.success) {
                let handlerShade=function (item) {
                    //get shade
                    if(windowHV==1){
                        if (item.tsinglemasksite) {//same
                            singleShade = baseDiyPath +item.tsinglemask;
                            if(item.tsinglemasksite && item.tsinglemasksite!=""){
                                let uvpictrueinfor=JSON.parse(item.tsinglemasksite);
                                defulatX=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                defulatY=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                defulatW=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                defulatH=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                            }
                        }
                        if(item.tpairmasksite) { //H  no same
                            twoSidedShade = baseDiyPath + item.tpairmask;
                            if(item.tpairmasksite && item.tpairmasksite!=""){
                                let uvpictrueinfor=JSON.parse(item.tpairmasksite);
                                defulatX2=uvpictrueinfor.x2/uvpictrueinfor.imgw;
                                defulatY2=uvpictrueinfor.y2/uvpictrueinfor.imgh;
                                defulatX1=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                defulatY1=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                defulatW1=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                defulatH1=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                            }
                        }
                    }else{
                        if (item.vsinglemasksite) {//same
                            singleShade = baseDiyPath +item.vsinglemask;
                            if(item.vsinglemasksite && item.vsinglemasksite!=""){
                                let uvpictrueinfor=JSON.parse(item.vsinglemasksite);
                                defulatX=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                defulatY=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                defulatW=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                defulatH=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                            }
                        }
                        if (item.vpairmasksite) { //H  no same
                            twoSidedShade = baseDiyPath + item.vpairmask;
                            if(item.vpairmasksite && item.vpairmasksite!=""){
                                let uvpictrueinfor=JSON.parse(item.vpairmasksite);
                                defulatX2=uvpictrueinfor.x2/uvpictrueinfor.imgw;
                                defulatY2=uvpictrueinfor.y2/uvpictrueinfor.imgh;
                                defulatX1=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                defulatY1=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                defulatW1=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                defulatH1=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                            }
                        }
                    }
                    if(productsType=="Planner"){
                        if(windowHV==2){
                            $(".page-change-canvas").css("top","10%");
                        }
                        $(".can-resource.can-resource1").append('<div class="planner-name" style="font-size: 16px;bottom: -30px;position: absolute;"><span>Front Cover</span></div>');
                        if (item.tsinglemasksite) {//same
                            singleShade = baseDiyPath +item.tsinglemask;
                            if(item.tsinglemasksite && item.tsinglemasksite!=""){
                                let uvpictrueinfor=JSON.parse(item.tsinglemasksite);
                                defulatX=uvpictrueinfor.x/uvpictrueinfor.imgw;
                                defulatY=uvpictrueinfor.y/uvpictrueinfor.imgh;
                                defulatW=uvpictrueinfor.clipw/uvpictrueinfor.imgw;
                                defulatH=uvpictrueinfor.cliph/uvpictrueinfor.imgh;
                            }
                        }
                        if(item.spareimg!=""){
                            let url=baseDiyPath + item.spareimg;
                            let path;
                            if(materialProduct=="spiral"){
                                //add black spiral
                                path=baseDiyPath +"MXYZ-A00DFF4EA84D4713ACDE3C9FBD255F13.png";
                                if(UploadProductType.UploadProductType.spiralColor=="white"){
                                    //white spiral
                                    url=baseDiyPath + item.spareimg;
                                    path=baseDiyPath +"/MXYZ-D9037FBD41874FE28736B02BECF214BC.png";
                                }
                            }else if(materialProduct=="soft"){
                                //MXYZ-3BD335060CA9433DA19A700D8CF9CD80.png soft
                                path=baseDiyPath +"/MXYZ-3BD335060CA9433DA19A700D8CF9CD80.png";
                            }else if(materialProduct=="hard"){
                                //MXYZ-0A52AC3732854B4592D40AEC9E797D10.png hard
                                path=baseDiyPath +"/MXYZ-0A52AC3732854B4592D40AEC9E797D10.png";
                            }
                            $(".can-resource.can-resource1").append('<div class="spiral-img left"><img src="'+path+'"></div>');
                            $(".spiral-img").css("height",($(".canvas-container").height()/($(".can-resource.can-resource1").innerHeight())*100)+"%");
                            let chanW=$(".spiral-img").width()/2;
                            if(materialProduct!="spiral"){
                                chanW=0;
                            }
                            let number = ($(".can-resource.can-resource1").width()/2-$(".canvas-container").width()/2-chanW)/$(".can-resource.can-resource1").width()*100;
                            $(".spiral-img").css("right","unset");
                            $(".spiral-img").css("left",number+"%");
                            $(".spiral-img").css("transform","rotate(180deg)");
                            imagemodelpath=url;
                            $(".paper-handbag-preview .preview-img").attr("src",url);
                        }
                    }
                    if(productsType=="Flyers"){
                        $(".page-change-canvas li img").attr("src",allCanvasArr[0].canvas.toDataURL());
                    }
                    // draw background and shade
                    if(productsType!="Planner" && singleShade){
                        if(productsType!="cup" && $('.bg-list-items .bg-item').length>0){
                            drawBgAndShade(singleShade,null,$('.bg-list-items .bg-item img:first').attr("src").replace("small","normal"));
                        }else {
                            drawBgAndShade(singleShade);
                        }
                    }
                    changeX=(defulatX-defulatX1)*canvas.width//defulatW*canvas.width*0.9;
                    changeX2=(defulatX2-defulatX)*canvas.width//defulatW*canvas.width*0.9;
                    changeY=(defulatY-defulatY1)*canvas.height//defulatH*canvas.height*0.62;
                    changeY2=(defulatY2-defulatY)*canvas.height//defulatH*canvas.height*0.62;
                }
                $(".bg-list-items").empty();
                productGoodsInfor=data.userData;
                $.each(data.userData, function (index, item) {
                    if(windowHV==1){
                        handlerBg(item,"tsingleback");
                    }else {
                        handlerBg(item,"vsingleback");
                    }
                    if(item.name.indexOf("默认样机")>-1){
                        imagemodelpath=baseDiyPath + item.prototype;
                    }
                    if(productGoodsInfor.length == 1){
                        imagemodelpath=baseDiyPath + item.prototype;
                    }
                    $(".paper-handbag-preview .preview-img").attr("src",imagemodelpath);
                    if(nameType == "insulatedCoolerBags" && item.spareimg){
                        $(".paper-handbag-preview .preview-model").find(".preview-front-coolers").remove();
                        $coolersImg = $("<img class='preview-front-coolers'>");
                        $coolersImg.attr("src",imagemodelpath=baseDiyPath + item.spareimg);
                        $(".paper-handbag-preview .preview-model").append($coolersImg);
                    }
                    handlerShade(item);
                });
                handlerDom();
                maxFontSize=parseInt(defulatH*canvas.height/1.16);
            }
        },
        error: function (err) {
            console.log(err);
        }
    });
}
let handlerBgColor=function (colorArr) {
    $(".bg-list-items").empty();
    if(nameType!="insulatedCoolerBags"){
        $(".bg-list-items").append('<div><input type="color" id="bgColorInput"><img src="https://cdn.shopify.com/s/files/1/0652/5029/6060/files/color-wheel.png?v=1732779901" style="width: 26px;"></div>');
    }
    for(let color of colorArr){
        let html = '<span class="bg-color" style="background-color: '+color+'" colorVal="'+color+'"></span>';
        $(".bg-list-items").append(html);
    }
}
//Designer operation button explicit and implicit control
let handlerDom=function () {
    $(".paper-handbag-Diy .choose-layout-btn input:first").prop("checked",true);
    $(".paper-handbag-Diy .choose-layout-btn span:first").addClass("active").siblings().removeClass("active");

    $(".paper-handbag-Diy .side-choose-btn input:first").prop("checked",true);
    $(".paper-handbag-Diy .side-choose-btn span:first").addClass("active").siblings().removeClass("active");
    $(".paper-handbag-Diy .uploadPropTipDiyzButtonFit").css('display','none');
    $('.choose-bg-style').css('display','none');
    if(productsType=="cup" || productsType=="bag"){
        if(nameType=="ribbonBag" || nameType=="insulatedCoolerBags"){// || nameType=="groceryBags"){
            $('.choose-bg-style').css('display','block');
            //add background-color
            let colorArr=["#D4B8B4", "#EC8F3F", "#597A69", "#75809C", "#F77E66", "#E6C786","#2A4C65","#FFFFFF","#000000"]
            if(nameType=="insulatedCoolerBags"){
                colorArr=["#FFFFFF", "#01A3EC", "#FECC1F", "#FF8C03", "#61CFAD", "#E82D1C","#E2CEB7"];
            }
            handlerBgColor(colorArr);
        }
        if(productsType=="cup" && materialProduct=="whitePaper"){
            $('.choose-bg-style').css('display','block');
        }
        if(windowHV==2){
            $('.choose-bg-style').css('display','block');
            $(".paper-handbag-Diy .can-resource").addClass("paper-handbag-clipPath");
            if(productsType=="bag"){
                $(".paper-handbag-Diy .choose-bg-style").addClass("bg-style-clipPath-bag");
                $(".paper-handbag-Diy .choose-bg-style").css('display','block');
            }else{
                $(".paper-handbag-Diy .choose-bg-style").addClass("bg-style-clipPath");
            }
            if($(".choose-bg-style .bg-color").length>0){
                $(".paper-handbag-Diy .choose-bg-style").addClass("bg-clipPath-bgcolor");
            }
        }
    }else if(newProduct.indexOf(productsType)>-1){
        if(windowHV==2){
            $(".paper-handbag-Diy .can-resource").css("top","30px")
        }
        $(".paper-handbag-Diy .single-both").css('display','none');
        $(".paper-handbag-Diy .uploadFileImg p").css('display','block');
        //Only the Tabletop Display displays a single/double page switch button
        if(productsType=="Tabletop Display"){
            $(".paper-handbag-Diy .single-both").css('display','block');
            $(".paper-handbag-Diy .uploadFileImg p").css('display','none');
        }else if(productsType=="Posters"){//Poster display adaptive button
            $(".paper-handbag-Diy .uploadPropTipDiyzButtonFit").css('display','block');
        }else if(productsType=="Puzzles"){
            $(".remove-Bg").css('display','none').siblings(".become-clearer").css('display','inline-block');
        }else if(productsType=="vinylbanner"){//add background-color
            let colorArr=["#000079","#FF0000","#F9F900","#FF8000","#272727","#BEBEBE","#ffffff"]
            $('.choose-bg-style').css('display','block');
            handlerBgColor(colorArr);
        }else if(productsType=="XBanners"){
            let colorArr=["#D4B8B4", "#EC8F3F", "#597A69", "#75809C", "#F77E66", "#E6C786","#2A4C65","#FFFFFF","#000000"];
            $('.choose-bg-style').css('display','block');
            $('.choose-bg-style').css('bottom','-10px');
            handlerBgColor(colorArr);
        }else if(productsType=="Placemats"){
            $(".paper-handbag-Diy .single-both").css('display','block');
            $(".paper-handbag-Diy .uploadFileImg p").css('display','none');
            $(".img-btn-box .preview").css('display','none');
            //let colorArr=["#D4B8B4", "#EC8F3F", "#597A69", "#75809C", "#F77E66", "#E6C786","#2A4C65","#FFFFFF","#000000"];
            //$('.choose-bg-style').css('display','block');
            //handlerBgColor(colorArr);
        }else if(productsType=="Flyers"){
            let colorArr=["#D4B8B4", "#EC8F3F", "#597A69", "#75809C", "#F77E66", "#E6C786","#2A4C65","#FFFFFF","#000000"];
            $('.choose-bg-style').css('display','block');
            handlerBgColor(colorArr);
            if(windowHV==1){
                $("#uploadPropTipDiyDivLeft").css("padding-bottom","0px");
            }
            $("#uploadPropTipDiyDivLeft").find("div.can-resource").css("padding-top","35px");
            $("#uploadPropTipDiyDivLeft").find("div.bg-list-items").css("padding-top","10px");
            $("#uploadPropTipDiyDivLeft").find("ul.page-change-canvas").css("width","5rem")
            $("#uploadPropTipDiyDivLeft ul.page-change-canvas").find("span").css("font-size","9px")
        }
        //Set size identification
        let workAreaArr = $('.newproductselectfirstchildSize').text().replaceAll('"',"").replaceAll(" ","").split("x");
        if(productsType=="Flyers"){
            if(parseFloat(workAreaArr[0])>parseFloat(workAreaArr[1])){
                $(".show-btn-direct li.h-show").addClass("on").siblings().removeClass("on");
            }else {
                $(".show-btn-direct li.v-show").addClass("on").siblings().removeClass("on");
            }
            $(".puzz-btn-tip").css('display','block');
        }
        if(productsType=="Puzzles"){
            workAreaArr=$('.newproductselectfirstchildSize').text().replaceAll('"',"").replaceAll(" ","").replaceAll(")","").replaceAll("(","").split("pieces")[1].split("x");
            if(parseFloat(workAreaArr[0])>parseFloat(workAreaArr[1])){
                $(".show-btn-direct li.h-show").addClass("on").siblings().removeClass("on");
            }else {
                $(".show-btn-direct li.v-show").addClass("on").siblings().removeClass("on");
            }
            $(".paper-handbag-preview .preview-img").attr("src",imagemodelpath);
            $(".puzz-btn-tip").css('display','block');
        }
        demensionNeed=true;
        setDemension(workAreaArr[0],workAreaArr[1]);
    }else if(productsType=="Planner"){
        //add background-color
        let colorArr=["#D4B8B4", "#EC8F3F", "#597A69", "#75809C", "#F77E66", "#E6C786","#2A4C65","#FFFFFF","#000000"];
        $('.choose-bg-style').css('display','block');
        handlerBgColor(colorArr);
        if(windowHV==2){
            $(".paper-handbag-Diy .can-resource").css("top","30px");
            $(".paper-handbag-Diy .can-resource").css("right","7%")
            $(".paper-handbag-Diy .can-resource").css("transform","scale(0.7)")
        }
    }
    drawGuideLine();
}
//Set size identification function
let setDemension = function(inchWidth,inchHeight){
    let canvas=allCanvasArr[currentNum].canvas;
    $(".paper-handbag-Diy .demension-h,.paper-handbag-Diy .demension-v").remove();
    if($('.demension-h').length == 0 && demensionNeed){
        $(".canvas-container").append('<div class="demension-h" id="widtho"  style="width:' + canvas.width + 'px;left:0px;">' +
            '<div class="line"></div>' +
            '<div class="text">' + inchWidth + ' in</div>' +
            '<div class="line"></div>' +
            '</div>');
        $(".canvas-container").append('<div class="demension-v"  id="heightv"  style="height:' + canvas.height + 'px;top:0px;">' +
            '<div class="line"></div>' +
            '<div class="text">' +  inchHeight + ' in</div>' +
            '<div class="line"></div>' +
            '</div>');
    }
    if(productsType=="Puzzles"){
        if(parseFloat(inchWidth)>parseFloat(inchHeight)){
            $(".show-btn-direct li.h-show").addClass("on").siblings().removeClass("on");
        }else {
            $(".show-btn-direct li.v-show").addClass("on").siblings().removeClass("on");
        }
    }
}
/****************Data preparation end**********************/

/**************** customer operation records start ********************/
let recordsParentid = "";
let optstepNum = 1;
let opearationRecords = function (recordsParentid, optbtn, optstepNum) {
    if (recordsParentid) {
        // debugger
        let data = {
            parentid: recordsParentid,
            optbtn: optbtn,
            optstep: optstepNum,
        };
        $.ajax({
            url: "https://diy.racetopprint.com/diyWeb/csrdiy/customerOperationRecords.do",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            success: function (res) {
                if (res.success) {}
            },
            error: function (error) {},
        });
    }
};

/**************** customer operation records end ********************/

/************** canvas init and close *******************/
//close canvas-container
function isInstructionsTipFun(){
    for (let item of allCanvasArr){
        item.canvas.dispose();
    }
    showTextTail(null, false);
    $(".paper-handbag-Diy").css('display','none');
    $(".uploadProp3Textareadiy").val("");
    $(".uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").val("");
    $(".paper-handbag-Diy .can-resource").empty();

    $('.uploadPropTipDiy').css('display','none')
    $('#ContinueFunzId1').prop('disabled', true);
    isaddcart = false;
    $('.canvas-container-init').css('display', 'flex');
    canvasSource = null;
    $('.remove-background,.become-clearer').addClass('on')
}
$(".paper-handbag-Diy .closeDesign").click(function () {
    if(isInstructionsTip){
        isInstructionsTipFun()
    }else{
        $('.InstructionsTip').css('display','block')
        isInstructionsTip=true
    }
});

// set canva size
let setCanvasSize=function (size,index) {
    let that=allCanvasArr[currentNum];
    if(index!=undefined){
        that=allCanvasArr[index];
    }
    that.canvas.setWidth(that.canFactWidth * size);
    that.canvas.setHeight(that.canFactHeight * size);
    that.canvas.setZoom(size);
    if(productsType=="Puzzles"){
        aspectRatio=that.canFactWidth/that.canFactHeight;
    }
}
let drawGuideLine=function () {
    for(let i=0;i<allCanvasArr.length;i++){
        let that=allCanvasArr[i];
        let canvas=that.canvas;
        let centerLineH = new fabric.Line([0,canvas.height/2, canvas.width, canvas.height/2], {
            stroke: '#287fcf',
            strokeDashArray: [3, 3],
            selectable: false,
            strokeWidth: 0.5,
        });
        centerLineH.objType='guideLine'
        canvas.add(centerLineH);
        that.guideLineH=centerLineH;
        let centerLineV = new fabric.Line([canvas.width/2, 0, canvas.width/2, canvas.height], {
            stroke: '#287fcf',
            strokeDashArray: [3, 3],
            selectable: false,
            strokeWidth: 0.5,
        });
        centerLineV.objType='guideLine'
        canvas.add(centerLineV);
        that.guideLineV=centerLineV;
        for(let item of canvas._objects){
            if(item.objType=="guideLine"){
                item.selectable=false;
                item.evented = false;
                item.isEdit = false;
                item.selectEnabled = false;
                item.selectable = false;
                item.visible=false;
            }
        }
    }
}
let guideLineLimit=3;
let handlerGuideLine=function (obj) {
    let that=allCanvasArr[currentNum];
    let canvas=that.canvas;
    let guideLineH=that.guideLineH;
    let guideLineV=that.guideLineV;
    let width=defulatW*canvas.width;
    let height=defulatH*canvas.height;
    let left=defulatX*canvas.width;
    let top=defulatY*canvas.height;
    if(oneOrTwoSide==1){
        if(windowHV==1){
            if(obj.getCenterPoint().x<canvas.width/2){
                left=defulatX1*canvas.width;
                top=defulatY1*canvas.height;
            }else {
                left=defulatX2*canvas.width;
                top=defulatY2*canvas.height;
            }
        }else {
            if(obj.getCenterPoint().y<canvas.height/2){
                left=defulatX1*canvas.width;
                top=defulatY1*canvas.height;
            }else {
                left=defulatX2*canvas.width;
                top=defulatY2*canvas.height;
            }
        }
    }
    guideLineH.setTop(top+height/2);
    guideLineH.setCoords();
    guideLineV.setLeft(left+width/2);
    guideLineV.setCoords();

    if((guideLineH.top-guideLineLimit)<obj.getCenterPoint().y && obj.getCenterPoint().y<=(guideLineH.top+guideLineLimit)){
        guideLineH.setVisible(true);
    }else {
        guideLineH.setVisible(false);
    }
    if((guideLineV.left-guideLineLimit)<obj.getCenterPoint().x && obj.getCenterPoint().x<=(guideLineV.left+guideLineLimit)){
        guideLineV.setVisible(true);
    }else {
        guideLineV.setVisible(false);
    }
}
let updateGuideLineShow=function (visible) {
    for(let item of allCanvasArr){
        if(visible!=undefined){
            if(item.guideLineV && item.guideLineV.canvas)item.guideLineV.setVisible(visible);
            if(item.guideLineH && item.guideLineH.canvas)item.guideLineH.setVisible(visible);
        }
        if(item.guideLineV && item.guideLineV.canvas)item.guideLineV.bringToFront();
        if(item.guideLineH && item.guideLineH.canvas)item.guideLineH.bringToFront();
    }
}
//init canvas
function initSizeCanvas() {
    let inchW,inchH,workAreaWidth,workAreaHeight;
    allCanvasArr=[];// all canvas obj
    currentNum=0;//current page num
    undoArr=[];
    textInfo=[];
    fullAll=false;
    let windowW=$("#uploadPropTipDiyDivLeft").width()*0.9;
    let windowH=$("#uploadPropTipDiyDivLeft").height()*0.9;
    let canvasNum=1;//canvas num
    let displayWidth=windowW;
    let displayHeight=displayWidth/3*2;
    if(windowHV==2){
        displayWidth=$(window).width()-100;
        displayHeight=displayWidth*3/2;
    }
    $(".paper-handbag-Diy .uploadPropTipDiyDivLeft").css('display','block');
    $(".product-submite-tip,.product-submite-tip .single-side-tip,.product-submite-tip .two-side-tip").css('display','none');
    fileUserIdA=undefined;
    fileUserIdB=undefined;
    imagemodelpath=undefined;
    nameType=UploadProductType.UploadProductType.name;
    materialProduct=UploadProductType.UploadProductType.type;
    if(nameType=="groceryBags" || nameType=="ribbonBag" || nameType=="insulatedCoolerBags"){
        if(UploadProductType.UploadProductType.diyPropColor){
            materialProduct=UploadProductType.UploadProductType.diyPropColor;
            materialProduct=materialProduct.toLowerCase().replaceAll(" ","");
        }
    }
    if(nameType=="plasticppcups"){
        if(UploadProductType.UploadProductType.type){
            materialProduct=materialProduct.toLowerCase().replaceAll(" ","");
        }
    }
    if(nameType=="handbag" || nameType=="heldBag"  || nameType=="toteBag" || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags" || nameType=="insulatedCoolerBags" || nameType=="Browntotebag"){
        productsType="bag"
    }else if(nameType=="cup" || nameType=="bowl" || nameType=="plasticppcups" || nameType=="plasticpetcups12oz" || nameType=="plasticpetcups16oz"){
        productsType="cup";
    }else{
        productsType=nameType;
    }
    $('.paper-handbag-Diy').addClass('dialog-' + nameType);
    $('.paper-handbag-Diy').addClass('dialog-p-' + productsType);
    if(productsType=="cup"){
        if(nameType=="cup"){
            if($('.newproductselectfirstchildSize').text()=="8 oz"){
                productSize="8oz";
            }else{
                productSize="12oz";
            }
        }else if(nameType=="bowl"){
            productSize=$('.newproductselectfirstchildSize').text().replaceAll(" ","");
        }else if(nameType=="plasticppcups"){
            productSize=$('.newproductselectfirstchildSize').text().replaceAll(" ","");
        }else if(nameType=="plasticpetcups12oz" || nameType=="plasticpetcups16oz"){
            productSize="";
        }

    }else if(productsType=="bag"){
        let nameSize=$('.newproductselectfirstchildSize').text();
        sizeArrWGH = nameSize.replaceAll('"','').split(" x ");
        let wSize=Number(sizeArrWGH[0].split("(")[1]);
        let gSize=Number(sizeArrWGH[2].split(")")[0]);
        if(isNaN(wSize)){
            wSize=Number(sizeArrWGH[0]);
        }
        if(isNaN(gSize)){
            gSize=Number(sizeArrWGH[2]);
        }
        aspectRatio=wSize/gSize;
        if(aspectRatio<1){
            productSize="A";
        }else if(aspectRatio==1){
            productSize="E";
        }else if(aspectRatio>1){
            productSize="F";
        }
        if(nameType=="heldBag" || nameType=="flatBag" || nameType=="ribbonBag"){
            productSize="A";
            if(aspectRatio>1){
                productSize="B";
            }
        }else if(nameType=="toteBag"){
            if(aspectRatio<1){
                productSize="A";
            }else if(aspectRatio>1){
                productSize="B";
            }
        }else if(nameType=="groceryBags"){
            if(sizeArrWGH[0] == 8 && sizeArrWGH[1] == 5 && sizeArrWGH[2] == 10){
                productSize="A";
            }else if(sizeArrWGH[0] == 9 && sizeArrWGH[1] == 6 && sizeArrWGH[2] == 10){
                productSize="B";
            }else if(sizeArrWGH[0] == 10 && sizeArrWGH[1] == 7 && sizeArrWGH[2] == 10){
                productSize="C";
            }else if(sizeArrWGH[0] == 12 && sizeArrWGH[1] == 4 && sizeArrWGH[2] == 15){
                productSize="D";
            }
        }else if(nameType=="insulatedCoolerBags"){
            if(sizeArrWGH[2]/sizeArrWGH[0]>2){
                productSize="A"
            }else if(sizeArrWGH[2]/sizeArrWGH[0]>1){
                productSize="B";
            }else if(sizeArrWGH[0] ==sizeArrWGH[2]){
                productSize="C";
            }
        }else if(nameType=="Browntotebag"){
            if(nameSize.indexOf("A")>=0){
                productSize="A";
            }else if(nameSize.indexOf("B")>=0){
                productSize="B";
            }else if(nameSize.indexOf("C")>=0){
                productSize="C";
            }else if(nameSize.indexOf("D")>=0){
                productSize="D";
            }else{
                productSize="E";
            }
        }

    }else if(newProduct.indexOf(productsType)>-1 || productsType=="Planner"){
        //["cup","handbag","Tabletop Display","vinylbanner","Retractable Banners","Posters"]
        let workAreaArr = $('.newproductselectfirstchildSize').text().replaceAll('"',"").replaceAll(" ","").split("x");
        if(productsType=="Puzzles"){
            workAreaArr=$('.newproductselectfirstchildSize').text().replaceAll('"',"").replaceAll(" ","").replaceAll(")","").replaceAll("(","").split("pieces")[1].split("x");
            aspectRatio=workAreaArr[0]/workAreaArr[1];
        }
        if(nameType == "XBanners"){
            productSize = workAreaArr.join("*");
        }
        inchW=Number(workAreaArr[0]);
        inchH=Number(workAreaArr[1]);
        workAreaWidth=inchW*25.4;
        workAreaHeight=inchH*25.4;
        if(windowHV==2){
            displayWidth=$(window).width()-100;
            displayHeight=displayWidth*3/2;
            displayHeight=displayWidth*workAreaHeight/workAreaWidth;
            if(displayHeight>displayWidth){
                displayHeight=displayWidth;
                displayWidth=displayHeight*workAreaWidth/workAreaHeight;
            }
            if(productsType=="Tabletop Display" || productsType=="Placemats"){
                canvasNum=2;
                displayWidth=displayWidth/2;
                if(productsType=="Placemats"){
                    displayHeight=displayWidth*workAreaHeight/workAreaWidth;
                    $(".img-btn-box").css("margin-bottom","-60px")
                }
            }else if(productsType=="Planner" || productsType=="Flyers"){
                canvasNum=2;
            }
        }else {
            if(749<$(window).width() && $(window).width()<1024){
                windowH=$(window).width()/3*2
            }
            if(windowW/windowH>inchW/inchH){
                displayHeight=windowH;
                displayWidth=displayHeight*workAreaWidth/workAreaHeight;
            }else {
                displayWidth=windowW;
                displayHeight=displayWidth*workAreaHeight/workAreaWidth;
            }
            if(productsType=="Tabletop Display" || productsType=="Placemats"){
                canvasNum=2;
                displayWidth=windowW/2;
                if(productsType=="Placemats"){
                    displayHeight=displayWidth*workAreaHeight/workAreaWidth;
                    $("#uploadPropTipDiyDivLeft").css("display","flex")
                    $("#uploadPropTipDiyDivLeft").css("justify-content","center")
                    $("#uploadPropTipDiyDivLeft").css("align-items","center")
                }
            }else if(productsType=="Planner" || productsType=="Flyers"){
                canvasNum=2;
            }
        }
    }
    oneOrTwoSide=0;
    $(".paper-handbag-Diy .singleUse").css('display','block');
    $(".paper-handbag-Diy .twoSideUse").css('display','none');
    $(".cartreloads").find("p").text("loading...");
    $(".cartreloads").css('display','block');
    $(".remove-Bg").removeClass("on");
    $(".become-clearer").removeClass("on");
    /************ Canvas diy start ****************/
    for(let i=0;i<canvasNum;i++){
        let pageCanvas={};
        let canvasId = "paperHandbag"+i;
        $(".paper-handbag-Diy .can-resource").append('<canvas id="'+canvasId+'" class="canvas-area"></canvas>');
        let canvasDom = document.getElementById(canvasId);
        pageCanvas.currentSize=1;
        pageCanvas.canFactWidth=displayWidth;
        pageCanvas.canFactHeight=displayHeight;
        pageCanvas.inchW=inchW;
        pageCanvas.inchH=inchH;
        pageCanvas.inchOriginW=inchW;
        pageCanvas.inchOriginH=inchH;
        pageCanvas.workAreaWidth=workAreaWidth;
        pageCanvas.workAreaHeight=workAreaHeight;
        pageCanvas.undoArr = [];
        canvasDom.width = displayWidth;
        canvasDom.height = displayHeight;
        pageCanvas.canvas = new fabric.Canvas(canvasId);
        pageCanvas.canvas.setBackgroundColor("#ffffff");
        pageCanvas.canvas.preserveObjectStacking = true;
        pageCanvas.canvas.renderAll();
        pageCanvas.canvas.on("object:modified", function (e) {
            let obj = e.target;
            undoArr.unshift(creatDesin());
            deleteBtnSet(true,obj);
        });
        pageCanvas.canvas.on("selection:created", function (e) {
            let obj = e.target;
            if(obj){
                if (obj.objType == "text") {
                    showTextTail(obj, true);
                } else {
                    showTextTail(obj, false);
                }
                deleteBtnSet(true,obj);
            }
        });

        pageCanvas.canvas.on("selection:updated", function (e) {
            let obj = e.target;
            if(obj){
                if (obj.objType == "text" || obj.type == "textbox") {
                    showTextTail(obj, true);
                } else {
                    showTextTail(obj, false);
                }
                deleteBtnSet(true,obj);
            }
        });

        pageCanvas.canvas.on("object:scaling", function (e) {
            let obj = e.target;
            if(obj){
                if(obj.objType == "text"){
                    let newScalWidth = obj.width * obj.scaleX;
                    let currentFontSize = Number((obj.getFontSize() * obj.scaleY).toFixed(1));
                    obj.scaleX = obj.scaleY = 1;
                    obj.setFontSize(currentFontSize);
                    obj.setWidth(newScalWidth);
                    $("#font-size-select .size-input").val(currentFontSize);
                }else if(obj.objType == "image"){
                    lowPixeCheck(obj);
                }else if(obj.type=="activeSelection"){
                    for(let item of obj._objects){
                        if(item.objType == "text"){
                            let newScalWidth = item.width * item.scaleX;
                            let currentFontSize = Number((item.getFontSize() * item.scaleY).toFixed(1));
                            item.scaleX = item.scaleY = 1;
                            item.setFontSize(currentFontSize);
                            item.setWidth(newScalWidth);
                        }else if(item.objType == "image"){
                            lowPixeCheck(item);
                        }
                    }
                }
            }
        });
        pageCanvas.canvas.on("object:moving", function (e) {
            let obj = e.target;
            deleteBtnSet(false,obj);
            checkObjPosition(obj);
            handlerGuideLine(obj);
        });
        pageCanvas.canvas.on("object:moved", function (e) {
            updateGuideLineShow(false);
        });
        pageCanvas.canvas.on("object:rotating", function (e) {
            let obj = e.target;
            deleteBtnSet(false,obj);
        });
        // pageCanvas.canvas.on("selection:updated", function (e) {
        //     let obj = e.selected;
        //     if (obj.objType == "text") {
        //         showTextTail(obj, true);
        //     } else {
        //         showTextTail(obj, false);
        //     }
        //     deleteBtnSet(true,obj);
        // });
        pageCanvas.canvas.on('text:changed', function (e) {
            let text=e.target.textLines.join("\n");
            $(".text-propty-item .text-content").val(text);
        })
        pageCanvas.canvas.on("before:selection:cleared", function (e) {
            let obj = e.target;
            showTextTail(obj, false,"cleared");
            deleteBtnSet(false,obj);
            checkObjPosition(obj);
        });
        pageCanvas.canvas.on("mouse:down:before", function (e) {
            currentNum=$(".can-resource .canvas-container").index($(e.e.target).parent());
            for(let i=0;i<allCanvasArr.length;i++){
                if(i!=currentNum){
                    allCanvasArr[i].canvas.deactivateAll();
                    allCanvasArr[i].canvas.renderAll();
                }
            }
        });
        $("#"+canvasId).parent().append('<span class="canvas-delet-item"><i class="backgroundImage backgroundImg delet-item"></i></span>');
        allCanvasArr.push(pageCanvas);
        if(i>0){
            $("#"+canvasId).parent().css('display','none');
        }
    }
    maxFontSize=parseInt(defulatH*allCanvasArr[currentNum].canvas.height/1.16);
    if(productsType=="cup" || nameType == "groceryBags" || nameType == "insulatedCoolerBags" || productsType == "XBanners" || nameType=="flatBag" || nameType == "Flyers" || nameType=="Browntotebag"){
        isNewType=true;
        let code=nameType+productSize;
        if(productsType=="cup"){
            if(nameType=="plasticppcups" && materialProduct != ""){
                code += materialProduct;
            }
        }
        if(productsType=="bag"){
            if(nameType=="groceryBags"){
                code = nameType+sizeArrWGH.join("*")+materialProduct
            }else if(nameType == "insulatedCoolerBags"){
                code += materialProduct;
            }else if(nameType=="flatBag"){
                var sizeStr = "A";
                if(sizeArrWGH[0].indexOf("B")>=0){
                    sizeStr = "B";
                }else if(sizeArrWGH[0].indexOf("C")>=0){
                    sizeStr = "B";
                }else if(sizeArrWGH[0].indexOf("D")>=0){
                    sizeStr = "D";
                }
                code = nameType+sizeStr+materialProduct
            }
            if(nameType=="Browntotebag"){
                code = nameType+productSize;
            }
        }
        if(productsType=="XBanners"){
            code = productsType+productSize
        }
        if(productsType=="Flyers"){
            code = productsType.toLowerCase();
        }
        newGetDataFun(code);
    }else {
        isNewType=false;
        getInitData();
    }
    setTimeout(function(params) {
        if(productsType=="Planner" || productsType=="Flyers"){
            $(".page-change-canvas li:first").trigger("click");
        }
        $(".cartreloads").css('display','none');
    },500);
    /************ Canvas diy end ****************/
}

// image show
let imgShowSet=function (oImg) {
    let that=allCanvasArr[currentNum];
    let canvas=allCanvasArr[currentNum].canvas;
    oImg.factWidth=oImg.width;
    oImg.factHeight=oImg.height;
    let width=defulatW*canvas.width;
    let height=defulatH*canvas.height;
    let left=defulatX*canvas.width;
    let top=defulatY*canvas.height;
    let roNormal=width/height;
    let roImg=oImg.width/oImg.height;
    let limitNum=2*2;
    let imgW,imgH;
    if(productsType=="Planner"){
        if(materialProduct=="spiral"){
            imgW=width;
            imgH=imgW/roImg;
            if(roNormal>roImg){
                imgH=height;
                imgW=imgH*roImg;
            }
            oImg.set("scaleX",imgW/ oImg.width);
            oImg.set("scaleY",imgH/ oImg.height);
            oImg.set("left",left);
            oImg.set("top",top+(height-imgH)/2);
        }else {
            imgW=width-$(".spiral-img").width();
            imgH=imgW/roImg;
            if(roNormal>roImg){
                imgH=height;
                imgW=imgH*roImg;
            }
            oImg.set("scaleX",imgW/ oImg.width);
            oImg.set("scaleY",imgH/ oImg.height);
            if(currentNum==0){
                oImg.set("left",$(".spiral-img").width());
            }else {
                oImg.set("left",0);
            }
            oImg.set("top",top+(height-imgH)/2);
        }
    }else {
        if(productsType=="cup" || productsType=="bag"){
            imgW=width*0.8;
            imgH=imgW/roImg;
            if(roNormal>roImg){
                imgH=height*0.8;
                imgW=imgH*roImg;
            }
        }else if(productsType=="Puzzles"){
            imgW=canvas.width;
            imgH=imgW/roImg;
            if(imgH<canvas.height){
                imgH=canvas.height;
                imgW=imgH*roImg;
            }
        }else {
            imgW=width-canvas.width/that.workAreaWidth*limitNum;
            imgH=imgW/roImg;
            if(roNormal>roImg){
                imgH=height-canvas.height/that.workAreaHeight*limitNum;
                imgW=imgH*roImg;
            }
        }
        if(fullAll){
            imgH=height;
            imgW=imgH*roImg;
        }
        oImg.set("scaleX",imgW/ oImg.width);
        oImg.set("scaleY",imgH/ oImg.height);
        oImg.set("left",left+(width-imgW)/2);
        oImg.set("top",top+(height-imgH)/2);
    }
}

let drawBgAndShade = function (shade, callBackFun, bgPath) {
    let canvas=allCanvasArr[currentNum].canvas;
    fabric.Image.fromURL(shade,function (Img) {
            canvas.setOverlayImage(Img,function () {
                    if(callBackFun){
                        callBackFun();
                    }
                    canvas.requestRenderAll();
                    if (bgPath) {
                        new fabric.Image.fromURL(bgPath,function (oImg) {
                                oImg.setWidth(canvas.width);
                                oImg.setHeight(canvas.height);
                                oImg.set("left",0);
                                oImg.set("top",0);
                                oImg.envent = false;
                                oImg.isBG = true;
                                oImg.objType = "image";
                                setObjProPerty(oImg);
                                canvas.add(oImg);
                                canvas.sendToBack(oImg);
                                canvas.renderAll();
                            }, {
                                crossOrigin: "anonymous"
                            }
                        );
                    }
                }, {
                    originX: "left",
                    originY: "top",
                    width: canvas.width,
                    height: canvas.height,
                    crossOrigin: "anonymous"
                }
            );
        }, {
            crossOrigin: "anonymous"
        }
    );
};

let setObjProPerty = function (obj) {
    if(obj){
        obj.setControlsVisibility({
            mt: false,
            mb: false,
            ml: false,
            mr: false,
            bl: false,
            br: true,
            tl: false,
            tr: false,
            mtr: false,
        });
        if (obj.type == "textbox") {
            obj.setControlsVisibility({
                mr: true,
                br: false,
            });
        }else if(obj.type == "image"){
            /*obj.setControlsVisibility({
                mtr: true,
            });*/
        }
        if (obj.isBG) {
            obj.evented = false;
            obj.selectable = false;
            obj.selectEnabled = false;
        }
    }
};
let creatDesin=function(index){
    updateGuideLineShow();
    let that=allCanvasArr[currentNum];
    if(index!=undefined){
        that=allCanvasArr[index];
    }
    let canvas=that.canvas;
    let propertArr=["isBG","nocropImg","uniqueid","objType"];
    let designJson=JSON.parse(JSON.stringify(canvas.toJSON(propertArr)));
    designJson.diyWorkAreaWidth=canvas.width;
    designJson.diyWorkAreaHeight=canvas.height;
    designJson.workAreaWidth=that.workAreaWidth;
    designJson.workAreaHeight=that.workAreaHeight;
    designJson.inchW=that.inchW;
    designJson.inchH=that.inchH;
    designJson.index=allCanvasArr.indexOf(that);
    return JSON.stringify(designJson);
}
let loadFromJSON = function (arr,callBack) {
    let designJson = JSON.parse(arr[1]);
    let that=allCanvasArr[designJson.index];
    let canvas=that.canvas;
    let overlayImage = canvas.overlayImage;
    canvas.setWidth(designJson.diyWorkAreaWidth);
    canvas.setHeight(designJson.diyWorkAreaHeight);
    that.workAreaWidth=designJson.workAreaWidth;
    that.workAreaHeight=designJson.workAreaHeight;
    that.inchW=designJson.inchW;
    that.inchH=designJson.inchH;
    canvas.loadFromJSON(designJson, function (o, object) {
        canvas.deactivateAll();
        canvas.overlayImage=overlayImage;
        canvas.renderAll();
        arr.splice(0, 1);
        if(that.inchW)setDemension(that.inchW,that.inchH);
        if(callBack){
            callBack();
        }
    }, function (o, object){
        setObjProPerty(object);
        if(o.isBG && o.objType=="image"){
            if(productsType=="cup"){
                let dom=$(".bg-list-items .bg-item img[osrc='"+o.src.replaceAll("normal","small")+"']");
                dom.parent().addClass("active")
                dom.parent().siblings().removeClass("active");
                let selectImgSrc=dom.attr("modelpath");
                if(selectImgSrc && selectImgSrc.length>1){
                    $(".paper-handbag-preview .preview-img").attr("src",selectImgSrc);
                }
            }
        }
        if(object.objType=="guideLine"){
            if(object.height==canvas.height){
                that.guideLineV=object;
                that.guideLineV.canvas=canvas;
            }else {
                that.guideLineH=object;
                that.guideLineH.canvas=canvas;
            }
        }
    });
};
// canvas redo
$(".paper-handbag-Diy .uploadPropTipDiyzButtonPrevious").on("click", function (params) {
    if(undoArr.length>1){
        loadFromJSON(undoArr,0);
        opearationRecords(recordsParentid, "Undo", optstepNum++);
    }
});

// delete canva object
$(".paper-handbag-Diy .can-resource").on("click",".canvas-delet-item",function (params) {
    let canvas=allCanvasArr[currentNum].canvas;
    let obj = canvas.getActiveObject();
    if(obj._objects){
        for(let i=0;i<obj._objects.length;i++){
            canvas.remove(obj._objects[i]);
        }
    }else{
        canvas.remove(obj);
    }
    deleteBtnSet(false,obj);
    canvas.renderAll();
    if(canvas._objects.length==0){
        ContinueFunzCupsIdHide();
    }
})
//change-canvas
$(".page-change-canvas li").on("click",function () {
    $(this).addClass("on").siblings().removeClass("on");
    let canvas=allCanvasArr[currentNum].canvas;
    updateGuideLineShow(false);
    let toDataURL = canvas.toDataURL();
    $(".page-change-canvas li").eq(currentNum).find("img").attr("src",toDataURL);
    if(currentNum!=$(this).index()){
        $(".remove-Bg").removeClass("on");
        $(".become-clearer").removeClass("on");
        undoArr = [];
        canvas.discardActiveObject();
        canvas.renderAll();
    }
    currentNum=$(this).index();
    $(".bg-list-items .active").removeClass("active");
    if(currentNum==0){
        $(".planner-name span").text("Front Cover");
    }else {
        $(".planner-name span").text("Back Cover");
    }
    if(productsType=="Planner" || productsType=="Flyers"){
        let chanW=$(".spiral-img").width()/2;
        if(materialProduct!="spiral"){
            chanW=0;
        }
        let number = ($(".can-resource.can-resource1").width()/2-$(".canvas-container").width()/2-chanW)/$(".can-resource.can-resource1").width()*100;
        if(currentNum==0){
            $(".spiral-img").css("right","unset");
            $(".spiral-img").css("left",number+"%");
            $(".spiral-img").css("transform","rotate(180deg)");
        }else {
            $(".spiral-img").css("left","unset");
            $(".spiral-img").css("right",number+"%");
            $(".spiral-img").css("transform","unset");
        }
    }
    $(".paper-handbag-Diy .can-resource .canvas-container").eq(currentNum).css('display','block').siblings(".canvas-container").css('display','none');
})

//Horizontal to Vertical
$(".show-btn-direct li").on("click",function () {
    for(let itemIndex = 0;itemIndex < allCanvasArr.length;itemIndex++){
        if(productsType == "Puzzles" && currentNum != itemIndex){
            continue;
        }
        let that=allCanvasArr[itemIndex];
        let canvas=that.canvas;
        if(!$(this).hasClass("on")){
            undoArr = [];
            canvas.discardActiveObject();
            canvas.renderAll();
        }
        $(this).addClass("on").siblings().removeClass("on");
        // origin data
        let objs = canvas.getObjects();
        let imgObj;
        for(let i=objs.length-1;i>-1;i--){
            if(objs[i].objType=="image"){
                if(!imgObj)imgObj=objs[i];
                if(canvas.width<=objs[i].getScaledWidth() && canvas.height<=objs[i].getScaledHeight()){
                    imgObj=objs[i];
                    break;
                }
            }
        }
        let relX=0,relY=0,relW=canvas.width,relH=canvas.height;
        if(imgObj){
            relX=imgObj.left;
            relY=imgObj.top;
            relW=imgObj.getScaledWidth();
            relH=imgObj.getScaledHeight();
        }
        objs.forEach(function(obj){
            if(obj.objType=="text"){
                obj.relRoaX=(obj.left-relX)/relW;
                obj.relRoaY=(obj.top-relY)/relH;
            }
        });
        //new canvas size
        let new_FH=that.canFactWidth;
        let new_FW=that.canFactHeight;
        that.canFactWidth=new_FW;
        that.canFactHeight=new_FH;
        setCanvasSize(1,itemIndex);
        let new_inchH=that.inchW;
        let new_inchW=that.inchH;
        that.inchW=new_inchW;
        that.inchH=new_inchH;
        let new_workAreaHeight=that.workAreaWidth;
        let new_workAreaWidth=that.workAreaHeight;
        that.workAreaWidth=new_workAreaWidth;
        that.workAreaHeight=new_workAreaHeight;
        setDemension(that.inchW,that.inchH);
        if(productsType == "Puzzles"){
            if($(this).hasClass("v-show")){
                $(".paper-handbag-preview .preview-img").attr("src",puzzPreviewV);
                imagemodelpath=puzzPreviewV;
            }else {
                $(".paper-handbag-preview .preview-img").attr("src",puzzPreviewH);
                imagemodelpath=puzzPreviewH;
            }
        }
        $(".paper-handbag-preview .preview-img").attr("src",imagemodelpath);

        //new canvas content data
        objs.forEach(function(obj){
            if(obj.objType=="image"){
                let roImg=obj.width/obj.height
                let imgW=canvas.width;
                let imgH=imgW/roImg;
                if(imgH<canvas.height){
                    imgH=canvas.height;
                    imgW=imgH*roImg;
                }
                obj.set("scaleX",imgW/obj.width);
                obj.set("scaleY",imgH/obj.height);
                obj.center();
                obj.setCoords();
            }
        });
        let imgObjNew;
        for(let i=objs.length-1;i>-1;i--){
            if(objs[i].objType=="image"){
                if(!imgObjNew)imgObj=objs[i];
                if(canvas.width<=objs[i].getScaledWidth() && canvas.height<=objs[i].getScaledHeight()){
                    imgObjNew=objs[i];
                    break;
                }
            }
        }
        for(let i=0;i<objs.length;i++){
            let obj=objs[i];
            if(obj.objType=="text"){
                if(imgObjNew){
                    obj.setLeft(imgObjNew.left+obj.relRoaX*imgObjNew.getScaledWidth())
                    obj.setTop(imgObjNew.top+obj.relRoaY*imgObjNew.getScaledHeight())
                }else {
                    obj.setLeft(obj.relRoaX*canvas.width)
                    obj.setTop(obj.relRoaY*canvas.height)
                }
                obj.setCoords();
            }
            if(obj.objType=="shape"){
                obj.setWidth(canvas.width)
                obj.setHeight(canvas.height)
                obj.setCoords();
            }

        }
        canvas.deactivateAll();
        canvas.renderAll();
        undoArr.unshift(creatDesin());
        if(productsType == "Flyers"){
            let toDataURL = canvas.toDataURL();
            $(".page-change-canvas li").eq(itemIndex).find("img").attr("src",toDataURL);
            if(canvas.width > canvas.height){
                if((canvas.width/canvas.height)>2){
                    $("#uploadPropTipDiyDivLeft").find("div.bg-list-items").css("padding-top","60px");
                }else if((canvas.width/canvas.height)>1){
                    $("#uploadPropTipDiyDivLeft").find("div.bg-list-items").css("padding-top","35px");
                }
                $(".page-change-canvas li").find("img").css("width","80%").css("height","auto");
                $("#uploadPropTipDiyDivLeft").find("div.can-resource").css("padding-top","95px");
            }else{
                $(".page-change-canvas li").find("img").css("height","80%").css("width","auto");
                $("#uploadPropTipDiyDivLeft").find("div.can-resource").css("padding-top","35px");
                $("#uploadPropTipDiyDivLeft").find("div.bg-list-items").css("padding-top","10px");
            }
        }
        
    }
})
$(document).on("mousedown",function(e){
    if($(e.target).parents(".align-menu").length==0){
        $(".align-menu").css("display","none");
    }
})
/*********************************/

/************ Image operate start****************/
let lowPixeCheck=function (obj) {
    let lowPixe=false;
    let that=allCanvasArr[currentNum];
    let workWidthDpi=that.workAreaWidth/inchMM*dpi;
    let itemScale=workWidthDpi/that.canFactWidth;
    let maxDIYWidth = obj.width/itemScale;
    let imgWidth=obj.getScaledWidth();
    if(imgWidth/maxDIYWidth>2){
        lowPixe=true;
    };
    console.log(imgWidth/maxDIYWidth);
    if(lowPixe){
        tipShow("Resolution below 300 dpi? No worries! A clear proof version will be sent within 24 hours of ordering!");
    }
}
// add-img-upload
function buttonCl(){
    $('#ContinueFunzCupsId').css('pointer-events', 'initial')
    $('#ContinueFunzCupsId').css('background', '#000')
    isInstructionsTip=false
}
$(".uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").change(function () {
    let dom=$(this);
    if(productsType=="Tabletop Display" || productsType=="Placemats"){
        if($(dom).hasClass('uploadImgDiyB')){
            currentNum=1;
        }else {
            currentNum=0;
        }
    }
    let canvas=allCanvasArr[currentNum].canvas;
    $(".cartreloads").find("p").text("Uploading...");
    $(".cartreloads").css('display','block');
    let formData = new FormData();
    if (!dom[0].files.length) {
        $(".cartreloads").css('display','none');
        tipShow("Please select a file");
        return;
    }
    let str =dom[0].files[0].name.split(".")[dom[0].files[0].name.split(".").length - 1];
    formData.append("file", dom[0].files[0]);
    formData.append("goodsname", $(".product__titleh1").text());
    if ($(".uploadProp3Textarea").val()) {
        formData.append("remark", $(".uploadProp3Textareadiy").val());
    }
    if (!$(".product-submite-tip").is(":visible")&& (str.indexOf('jpeg')>=0||str.indexOf('jpg')>=0||str.indexOf('png')>=0||str.indexOf('heic')>=0||str.indexOf('webp')>=0||str.indexOf('pdf')>=0||str.indexOf('JPEG')>=0||str.indexOf('JPG')>=0||str.indexOf('PNG')>=0||str.indexOf('HEIC')>=0||str.indexOf('WEBP')>=0||str.indexOf('PDF')>=0)) {
        opearationRecords(recordsParentid, "Choose Image", optstepNum++);
        $.ajax({
            url: "https://diy.racetopprint.com/zlgao/outsideUploadFile/fileUploadnew.do",
            type: "post",
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            success: (res) => {
                if (res.result == "true") {
                    if(document.querySelector('.pdf-more-tooltip-content') != null){
                        document.querySelector('.pdf-more-tooltip-content').style.display = 'none';
                        document.querySelector('.pdf-more-tooltip').style.display = 'none';
                    }
                    let drawImageUrl = res.path;
                    // drawImageUrl = drawImageUrl.split('!')[0]
                    // limit size
                    if(res.widthpx > res.hightpx){
                        drawImageUrl = drawImageUrl.split('!')[0] + '!' + '4000x0';
                    }else{
                        drawImageUrl = drawImageUrl.split('!')[0] + '!' + '0x4000';
                    }
                    if(window.location.hostname == "127.0.0.1"){
                        drawImageUrl = drawImageUrl.slice(0,drawImageUrl.indexOf("!"));
                    }
                    // upload more page pdf tip
                    if((str.indexOf('pdf')>=0 || str.indexOf('PDF')>=0) && res.isflow && res.isflow == '1'){
                        console.log('upload more page pdf');
                        if(document.querySelector('.pdf-more-tooltip-content') != null){
                            document.querySelector('.pdf-more-tooltip').style.display = 'block';
                            document.querySelector('.pdf-more-tooltip-content').style.display = 'flex';
                        }
                        if (window.addProductUploadPdfTooltipFun) {
                            window.addProductUploadPdfTooltipFun()
                        }
                    }
                    new fabric.Image.fromURL(drawImageUrl,function (oImg) {
                        if (oImg.getWidth() == 0 || oImg.getHeight() == 0) {
                            $(".cartreloads").css('display','none');
                            tipShow("upload fail...");
                            $(".uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").val("");
                            return;
                        }
                        oImg.uniqueid=res.id;
                        imgShowSet(oImg);
                        oImg.objType = "image";
                        setObjProPerty(oImg);
                        if(windowHV==2  && !(nameType== "insulatedCoolerBags" && productSize=="A")){//Vertical adjustment on mobile
                            if($(dom).hasClass('uploadImgDiyA')){
                                oImg.set("top",oImg.top-changeY);
                            }else if($(dom).hasClass('uploadImgDiyB')){
                                oImg.set("top",oImg.top+changeY2);
                            }
                        }else{//Horizontal adjustment on PC
                            if($(dom).hasClass('uploadImgDiyA')){
                                oImg.set("left",oImg.left-changeX);
                            }else if($(dom).hasClass('uploadImgDiyB')){
                                oImg.set("left",oImg.left+changeX2);
                            }
                        }
                        canvas.add(oImg);
                        canvas.setActiveObject(oImg);
                        canvas.renderAll();
                        $(".remove-Bg").removeClass("on");
                        $(".become-clearer").removeClass("on");
                        $(".cartreloads").css('display','none');
                        undoArr.unshift(creatDesin());
                        $(".uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").val("");
                        // warnPix
                        lowPixeCheck(oImg);
                    }, {
                        crossOrigin: "anonymous"
                    });
                    $(".uploadImgInput").val(res.path);
                    productVarId=res.id
                    $(".uploadImgid").val(res.id);
                    buttonCl()
                    uploadSuccess()
                } else {
                    $(".cartreloads").css('display','none');
                    tipShow(res.message);
                }
            },
            error: function (e) {
                $(".cartreloads").css('display','none');
                tipShow("upload fail...");
                $(".uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").val("");
            },
        });
    }else{
        //Upload manuscript
        opearationRecords(recordsParentid, "Choose Image", optstepNum++);
        $.ajax({
            url: locaUploadzlg,
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: res => {
                $('.container').css('display','none')
                if (res.result == 'true') {
                    $('#ContinueFunzId').css('pointer-events', 'initial')
                    $('#ContinueFunzId').css('background', '#000')
                    $('.Continue').css('background', '#000')
                    $('.Continue').css('pointer-events', 'initial')
                    $('.designUpload').attr('src', res.path)
                    $('.designUploadclose').css('display','block')
                    $('.uploadProp1 span').text(res.path)
                    $('.uploadImgInput').val(res.path)
                    $('.uploadImgid').val(res.id)
                    // $('.uploadImgidrema').val($('.uploadProp3Textarea').val());
                    $(".uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").val("");
                    recordsParentid=res.id;
                    $(".cartreloads").css('display','none');
                    $(".product-submite-tip").css('display','block');
                    $(".product-submite-tip .single-side-tip,.product-submite-tip .two-side-tip,.paper-handbag-Diy .uploadPropTipDiyDivLeft").css('display','none');
                    if($(dom).hasClass('uploadImgDiy')){
                        fileUserIdA=res.id+"&&"+res.path;
                        $(".product-submite-tip .single-side-tip").css('display','block');
                    }else if($(dom).hasClass('uploadImgDiyA')){
                        $(".product-submite-tip .two-side-tip").css('display','block');
                        $(".product-submite-tip .two-side-tip .two-side-left").css('display','block');
                        fileUserIdA=res.id+"&&"+res.path;
                        if(!fileUserIdB){
                            $(".product-submite-tip .two-side-tip .two-side-right").css('display','none');
                        }else {
                            $(".product-submite-tip .two-side-tip .two-side-right").css('display','block');
                        }
                    }else if($(dom).hasClass('uploadImgDiyB')){
                        fileUserIdB=res.id+"&&"+res.path;
                        $(".product-submite-tip .two-side-tip").css('display','block');
                        $(".product-submite-tip .two-side-tip .two-side-right").css('display','block');
                        if(!fileUserIdA){
                            $(".product-submite-tip .two-side-tip .two-side-left").css('display','none');
                        }else {
                            $(".product-submite-tip .two-side-tip .two-side-left").css('display','block');
                        }
                    }
                    buttonCl();
                }
                $(".cartreloads").css('display','none');
                tipShow(res.message)
            },
            error: function (e) {
                $(".cartreloads").css('display','none');
                tipShow("upload fail...");
                $(".uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").val("");
            },
        })
    }
});

//remove-Bg
$(".remove-Bg").click(function () {
    let canvas=allCanvasArr[currentNum].canvas;
    let obj = canvas.getActiveObject();
    if (obj && obj.objType == "image") {
        let isClear = false;
        if (obj.isClear) {
            isClear = obj.isClear;
        }
        // reload
        if ($(this).hasClass("on")) {
            opearationRecords(
                recordsParentid,
                "Revert Remove background",
                optstepNum++
            );
            $(".cartreloads").find("p").text("resetting...");
            $(".cartreloads").css('display','block');
            $(this).removeClass("on");
            new fabric.Image.fromURL(
                obj.nocropImg.path,
                function (oImg) {
                    let oldW=obj.getScaledWidth();
                    let oldH=obj.getScaledHeight();
                    let oRa=oldW/oldH;
                    let newRa=oImg.width/oImg.height;
                    let showW=oldW;
                    let showH=oldW/newRa;
                    if(oRa>newRa){
                        showH=oldH;
                        showW=showH*newRa;
                    }
                    if(obj.nocropImg){
                        oImg.set("scaleX",obj.nocropImg.width/ oImg.width);
                        oImg.set("scaleY",obj.nocropImg.height/ oImg.height);
                        oImg.set("left",obj.left+(obj.getScaledWidth()-obj.nocropImg.width)/2);
                        oImg.set("top",obj.top+(obj.getScaledHeight()-obj.nocropImg.height)/2);
                    }else {
                        oImg.set("scaleX",showW/ oImg.width);
                        oImg.set("scaleY",showH/ oImg.height);
                        oImg.set("left",obj.left+(obj.getScaledWidth() - oImg.getScaledWidth()) / 2);
                        oImg.set("top",obj.top+(obj.getScaledHeight() - oImg.getScaledHeight()) / 2);
                    }
                    if(obj.uniqueid){
                        oImg.uniqueid = obj.uniqueid
                    }
                    canvas.remove(obj);
                    oImg.objType = "image";
                    if (isClear) {
                        oImg.isClear = isClear;
                    }
                    setObjProPerty(oImg);
                    canvas.add(oImg);
                    canvas.setActiveObject(oImg);
                    canvas.renderAll();
                    $(".cartreloads").css('display','none');
                    undoArr.unshift(creatDesin());
                }, {
                    crossOrigin: "anonymous"
                }
            );
        } else {
            opearationRecords(recordsParentid, "Remove background", optstepNum++);
            $(".cartreloads").find("p").text("Remove background...");
            $(".cartreloads").css('display','block');
            $(this).addClass("on");
            let canvasImg = obj.getSrc();
            $.ajax({
                url: "https://diy.racetopprint.com/diyWeb/commontool/cutOutUploadPixian.do",
                method: "post",
                data: {
                    imagePath: canvasImg,
                },
                success: function (data) {
                    if (data.success) {
                        if (data.userData.uploadImage == "") {
                            $(".cartreloads").css('display','none');
                            tipShow("Remove background failed");
                            return;
                        }
                        new fabric.Image.fromURL(
                            "https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/" +
                            data.userData.uploadImage,
                            function (oImg) {
                                let oldW=obj.getScaledWidth();
                                let oldH=obj.getScaledHeight();
                                let oRa=oldW/oldH;
                                let newRa=oImg.width/oImg.height;
                                let showW=oldW;
                                let showH=oldW/newRa;
                                if(oRa>newRa){
                                    showH=oldH;
                                    showW=showH*newRa;
                                }
                                oImg.set("scaleX",showW/ oImg.width);
                                oImg.set("scaleY",showH/ oImg.height);
                                oImg.set("left",obj.left+(obj.getScaledWidth() - oImg.getScaledWidth()) / 2);
                                oImg.set("top",obj.top+(obj.getScaledHeight() - oImg.getScaledHeight()) / 2);
                                if(obj.uniqueid){
                                    oImg.uniqueid = obj.uniqueid
                                }
                                canvas.remove(obj);
                                oImg.nocropImg = {
                                    path:canvasImg,
                                    width:oldW,
                                    height:oldH
                                };
                                oImg.objType = "image";
                                oImg.isCrop = true;
                                if (isClear) {
                                    oImg.isClear = isClear;
                                }
                                setObjProPerty(oImg);
                                canvas.add(oImg);
                                canvas.setActiveObject(oImg);
                                canvas.renderAll();
                                $(".cartreloads").css('display','none');
                                undoArr.unshift(creatDesin());
                            }, {
                                crossOrigin: "anonymous"
                            }
                        );
                    } else {
                        $(".cartreloads").css('display','none');
                        tipShow("Remove background failed");
                    }
                },
                error: function (data) {
                    $(".cartreloads").css('display','none');
                    tipShow("Remove background failed");
                },
            });
        }
    } else {
        $(".cartreloads").css('display','none');
        tipShow("Please selecte picture！");
    }
});

//become-clearer
$(".become-clearer").click(function () {
    let canvas=allCanvasArr[currentNum].canvas;
    let obj = canvas.getActiveObject();
    if (obj && obj.objType == "image") {
        let isCrop = false;
        if (obj.isCrop) {
            isCrop = obj.isCrop;
        }
        // reload
        if ($(this).hasClass("on")) {
            opearationRecords(recordsParentid, "Revert Become clearer", optstepNum++);
            $(".cartreloads").find("p").text("resetting...");
            $(".cartreloads").css('display','block');
            $(this).removeClass("on");
            new fabric.Image.fromURL(
                obj.noclearImg,
                function (oImg) {
                    oImg.set("scaleX",obj.getScaledWidth() / oImg.width);
                    oImg.set("scaleY",obj.getScaledHeight() / oImg.height);
                    oImg.set("left",obj.left);
                    oImg.set("top",obj.top);
                    oImg.objType = "image";
                    if (isCrop) {
                        oImg.isCrop = isCrop;
                    }
                    if(obj.uniqueid){
                        oImg.uniqueid = obj.uniqueid
                    }
                    canvas.remove(obj);
                    setObjProPerty(oImg);
                    canvas.add(oImg);
                    canvas.renderAll();
                    $(".cartreloads").css('display','none');
                    undoArr.unshift(creatDesin());
                }, {
                    crossOrigin: "anonymous"
                }
            );
        } else {
            opearationRecords(recordsParentid, "Become clearer", optstepNum++);
            $(".cartreloads").find("p").text("Become clearer...");
            $(".cartreloads").css('display','block');
            $(this).addClass("on");
            let canvasImg = obj.getSrc();
            if (canvasImg.indexOf("!") != -1) {
                canvasImg = canvasImg.split("!")[0];
            } else {
                canvasImg = canvasImg.replace("large", "normal");
            }
            $.ajax({
                url: "https://diy.racetopprint.com/diyWeb/csrdiy/maskSuperResolutionImage_sjky.do",
                method: "get",
                data: {
                    imagePath: canvasImg,
                },
                success: function (data) {
                    if (data.success) {
                        if (data.userData.imagePath == "") {
                            $(".cartreloads").css('display','none');
                            tipShow("Become clearer failed");
                            return;
                        }
                        let imgPathClear=data.userData.imagePath
                        if(data.userData.imagePath.indexOf("ttps://diy.racetopprint.com")<0){
                            imgPathClear="https://diy.racetopprint.com/diyWeb/assets/resource/imgs/normal/"+data.userData.imagePath
                        }
                        new fabric.Image.fromURL(imgPathClear,
                            function (oImg) {
                                oImg.set("scaleX",obj.getScaledWidth() / oImg.width);
                                oImg.set("scaleY",obj.getScaledHeight() / oImg.height);
                                oImg.set("left",obj.left);
                                oImg.set("top",obj.top);
                                oImg.objType = "image";
                                oImg.noclearImg = oImg.getSrc();
                                if (isCrop) {
                                    oImg.isCrop = isCrop;
                                }
                                if(obj.uniqueid){
                                    oImg.uniqueid = obj.uniqueid
                                }
                                canvas.remove(obj);
                                setObjProPerty(oImg);
                                canvas.add(oImg);
                                canvas.renderAll();
                                $(".cartreloads").css('display','none');
                                undoArr.unshift(creatDesin());
                            }, {
                                crossOrigin: "anonymous"
                            }
                        );
                    } else {
                        $(".cartreloads").css('display','none');
                        tipShow("Become clearer failed");
                    }
                },
                error: function (data) {
                    $(".cartreloads").css('display','none');
                    tipShow("Become clearer failed");
                },
            });
        }
    } else {
        $(".cartreloads").css('display','none');
        tipShow("Please selecte picture！");
    }
});

// change layout
$(".choose-layout-btn span").on("click", function (params) {
    $(this).find("input").prop("checked",true);
    $(this).addClass("active").siblings().removeClass("active");
    let layOutType = $(this).find("input").attr("val");
    let canvas=allCanvasArr[currentNum].canvas;
    if(layOutType==0){
        fullAll=false;
    }else if(layOutType==1){
        fullAll=true;
    }
    $('.cartreloads').css('display','block');
    $(".cartreloads").find("p").text("change begin...");
    canvas.deactivateAll();
    canvas.renderAll();
    for (let oImg of canvas._objects){
        if(oImg.objType=="image" && !oImg.isBG){
            let centerY=oImg.getCenterPoint().y;
            let centerX=oImg.getCenterPoint().x;
            imgShowSet(oImg);
            canvas.renderAll();
            if(oneOrTwoSide==1){
                if(windowHV==2){//Vertical adjustment on mobile
                    if(centerY<canvas.height/2){
                        oImg.set("top",oImg.top-changeY);
                    }else if(centerY>canvas.height/2){
                        oImg.set("top",oImg.top+changeY2);
                    }
                }else{//Horizontal adjustment on PC
                    if(centerX<canvas.width/2){
                        oImg.set("left",oImg.left-changeX);
                    }else if(centerX>canvas.width/2){
                        oImg.set("left",oImg.left+changeX2);
                    }
                }
            }
        }
    }
    canvas.renderAll();
    $('.cartreloads').css('display','none');
})

// change shade
$(".side-choose-btn span").on("click", function (params) {
    let canvas=allCanvasArr[currentNum].canvas;
    $(this).find("input").prop("checked",true);
    let shadeType = $(this).find("input").attr("val");
    if($(".product-submite-tip").is(":visible")){
        if (shadeType == 0 && oneOrTwoSide!=0) {
            $(".paper-handbag-Diy .singleUse").css('display','block');
            $(".paper-handbag-Diy .twoSideUse").css('display','none');
            oneOrTwoSide=0;
            $(".product-submite-tip .single-side-tip").css('display','block');
            $(".product-submite-tip .two-side-tip").css('display','none');
            $(".product-submite-tip .two-side-tip .two-side-left").css('display','block');
            $(".product-submite-tip .two-side-tip .two-side-right").css('display','none');
        }else if(shadeType == 1 && oneOrTwoSide!=1){
            $(".paper-handbag-Diy .singleUse").css('display','none');
            $(".paper-handbag-Diy .twoSideUse").css('display','block');
            oneOrTwoSide=1;
            $(".product-submite-tip .two-side-tip").css('display','block');
            $(".product-submite-tip .single-side-tip").css('display','none');
            $(".product-submite-tip .two-side-tip .two-side-left").css('display','none');
            $(".product-submite-tip .two-side-tip .two-side-right").css('display','none');
            if(fileUserIdA){
                $(".product-submite-tip .two-side-tip .two-side-left").css('display','block');
            }
            if(fileUserIdB){
                $(".product-submite-tip .two-side-tip .two-side-right").css('display','block');
            }
        }
        return;
    }
    deleteBtnSet(false);
    let changTop=0.1*canvas.height;
    $('.cartreloads').css('display','block');
    $(".cartreloads").find("p").text("change begin...");
    if(productsType=="cup" || productsType=="bag"){
        if (shadeType == 0 && oneOrTwoSide!=0) { //same
            drawBgAndShade(singleShade);
            if(windowHV==2){//Mobile mode vertical
                if(nameType=="toteBag" || nameType=="heldBag" || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags" || nameType == "insulatedCoolerBags" || nameType == "Browntotebag"){
                    getBackGroundFun(nameType+productSize+"VSingle");
                }else {
                    getBackGroundFun(productsType+productSize+"VSingle");
                }
            }else{//PC mode horizontal
                if(nameType=="toteBag" || nameType=="heldBag"  || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags"  || nameType == "insulatedCoolerBags"){
                    getBackGroundFun(nameType+productSize+"VSingle");
                }else{
                    getBackGroundFun(productsType+productSize+"HSingle");
                }
            }
            //Optimization of single-sided style on mobile devices
            if(windowHV==2 && (productsType=="cup" || productsType=="bag")){
                $(".paper-handbag-Diy .can-resource").addClass("paper-handbag-clipPath");
                if(productsType=="bag"){
                    $(".paper-handbag-Diy .choose-bg-style").addClass("bg-style-clipPath-bag");
                    $(".paper-handbag-Diy .choose-bg-style").css('display','block');
                    if(nameType=="ribbonBag" && aspectRatio>1){
                        $(".paper-handbag-Diy .can-resource").addClass("H");
                    }
                }else{
                    $(".paper-handbag-Diy .choose-bg-style").addClass("bg-style-clipPath");
                }
                if($(".choose-bg-style .bg-color").length>0){
                    $(".paper-handbag-Diy .bg-clipPath-bgcolor").removeClass("twoSide");
                }
            }
            $(".paper-handbag-Diy .singleUse").css('display','block');
            $(".paper-handbag-Diy .twoSideUse").css('display','none');
            oneOrTwoSide=0;
            for(let i=0;i<canvas._objects.length;i++){
                let item=canvas._objects[i];
                if(item.objType!="guideLine"){
                    if(item.isBG==undefined){
                        if(windowHV==2 && !(nameType== "insulatedCoolerBags" && productSize=="A")){//Vertical adjustment on mobile
                            if(item.top>canvas.height/2){
                                canvas.remove(item);
                                i--;
                            }else if(item.top<canvas.height/2){
                                item.set("top",item.top+changeY);
                                item.setCoords();
                            }
                        }else{//Horizontal adjustment on PC
                            if(item.left>canvas.width/2){
                                canvas.remove(item);
                                i--;
                            }else if(item.left<canvas.width/2){
                                item.set("left",item.left+changeX);
                                if(nameType != "Browntotebag"){
                                    if(productSize=="E"){
                                        item.set("top",item.top-changTop);
                                    }else if(productSize=="F"){
                                        item.set("top",item.top-changTop/2);
                                    }
                                }
                                item.setCoords();
                            }
                        }
                    }else{
                        if(productsType!="bag"){
                            canvas.remove(item);
                            i--;
                        }
                    }
                }
            }
            canvas.renderAll();
            setTimeout(function name(params) {
                undoArr=[];
                undoArr.unshift(creatDesin());
                $('.cartreloads').css('display','none');
            },100)
        } else if (shadeType == 1 && oneOrTwoSide!=1) { // no same
            drawBgAndShade(twoSidedShade);
            if(windowHV==2){//Mobile mode vertical double-sided
                if(nameType=="toteBag" || nameType=="heldBag"  || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags"  || nameType == "insulatedCoolerBags" || nameType == "Browntotebag"){
                    getBackGroundFun(nameType+productSize+"VSingle");
                }else {
                    getBackGroundFun(productsType+productSize+"VTwo");
                }
            }else{//PC mode horizontal double-sided
                if(nameType=="toteBag" || nameType=="heldBag"  || nameType=="flatBag" || nameType=="ribbonBag" || nameType=="groceryBags"  || nameType == "insulatedCoolerBags"){
                    getBackGroundFun(nameType+productSize+"VSingle");
                }else {
                    getBackGroundFun(productsType+productSize+"HTwo");
                }
            }
            //Optimization of single-sided style on mobile devices
            if(windowHV==2 && (productsType=="cup" || productsType=="bag")){
                $(".paper-handbag-Diy .can-resource").removeClass("H");
                $(".paper-handbag-Diy .can-resource").removeClass("paper-handbag-clipPath");
                $(".paper-handbag-Diy .choose-bg-style").removeClass("bg-style-clipPath");
                if($(".choose-bg-style .bg-color").length>0){
                    $(".paper-handbag-Diy .bg-clipPath-bgcolor").addClass("twoSide");
                }
            }
            oneOrTwoSide=1;
            $(".paper-handbag-Diy .singleUse").css('display','none');
            $(".paper-handbag-Diy .twoSideUse").css('display','block');
            let addArr=[];
            for(let i=0;i<canvas._objects.length;i++){
                let item=canvas._objects[i];
                if(item.objType!="guideLine"){
                    if(item.isBG==undefined){
                        if(windowHV==2 && !(nameType== "insulatedCoolerBags" && productSize=="A")){//Vertical adjustment on mobile
                            (function(topNum) {
                                item.clone(function (clone) {
                                    clone.set("top",topNum+changeY2);
                                    setObjProPerty(clone);
                                    addArr.unshift(clone);
                                    //canvas.add(clone);
                                })
                            })(item.top);
                            item.set("top",item.top-changeY);
                            item.setCoords();
                            canvas.renderAll();
                        }else{//Horizontal adjustment on PC
                            (function(leftNum) {
                                item.clone(function (clone) {
                                    clone.set("left",leftNum+changeX2);
                                    if(nameType != "Browntotebag"){
                                        if(productSize=="E"){
                                            clone.set("top",clone.top+changTop);
                                        }else if(productSize=="F"){
                                            clone.set("top",clone.top+changTop/2);
                                        }
                                    }
                                    setObjProPerty(clone);
                                    addArr.unshift(clone);
                                    //canvas.add(clone);
                                    canvas.renderAll();
                                })
                            })(item.left);
                            item.set("left",item.left-changeX);
                            if(nameType != "Browntotebag"){
                                if(productSize=="E"){
                                    item.set("top",item.top+changTop);
                                }else if(productSize=="F"){
                                    item.set("top",item.top+changTop/2);
                                }
                            }
                            item.setCoords();
                        }
                    }else{
                        if(productsType!="bag"){
                            canvas.remove(item);
                            i--;
                        }
                    }
                }
            }
            canvas.renderAll();
            setTimeout(function name(params) {
                for(let item of addArr){
                    canvas.add(item);
                }
                undoArr=[];
                undoArr.unshift(creatDesin());
                $('.cartreloads').css('display','none');
            },100)
        }else {
            $('.cartreloads').css('display','none');
        }
    }else if(productsType=="Tabletop Display" || productsType=="Placemats"){
        if (shadeType == 0 && oneOrTwoSide!=0) { //same
            $(".paper-handbag-Diy .singleUse").css('display','block');
            $(".paper-handbag-Diy .twoSideUse").css('display','none');
            oneOrTwoSide=0;
            $(".paper-handbag-Diy .can-resource .canvas-container").removeClass("canvas-containerTabletop");
            $(".paper-handbag-Diy .can-resource .canvas-container:first").css('display','block').siblings().css('display','none');
        } else if (shadeType == 1 && oneOrTwoSide!=1) { // no same
            oneOrTwoSide=1;
            let designStr = JSON.parse(creatDesin(0));
            designStr.index=1;
            designStr=JSON.stringify(designStr);
            loadFromJSON([designStr,designStr]);
            $(".paper-handbag-Diy .singleUse").css('display','none');
            $(".paper-handbag-Diy .twoSideUse").css('display','block');
            $(".paper-handbag-Diy .can-resource .canvas-container").addClass("canvas-containerTabletop");
            $(".paper-handbag-Diy .can-resource .canvas-container").css('display','block');
        }
        setTimeout(function name(params) {
            $('.cartreloads').css('display','none');
            undoArr=[];
            undoArr.unshift(creatDesin());
        },100)
    }

})

//change image large
$(".paper-handbag-Diy .uploadPropTipDiyzButtonEnlarge").click(function () {
    let canvas=allCanvasArr[currentNum].canvas;
    let obj = canvas.getActiveObject();
    if (obj && obj.objType == "image") {
        obj.set("scaleX",obj.scaleX + 0.01);
        obj.set("scaleY",obj.scaleY + 0.01);
        canvas.renderAll();
        canvas.trigger("object:modified");
        opearationRecords(recordsParentid, "Image enlargement", optstepNum++);
    } else {
        tipShow("Please selecte picture！");
    }
});
// change image small
$(".paper-handbag-Diy .uploadPropTipDiyzButtonNarrow").click(function () {
    let canvas=allCanvasArr[currentNum].canvas;
    let obj = canvas.getActiveObject();
    if (obj && obj.objType == "image") {
        let scaleX=(obj.scaleX-0.01)<0.01?0.01:(obj.scaleX-0.01)
        let scaleY=(obj.scaleY-0.01)<0.01?0.01:(obj.scaleY-0.01)
        obj.set("scaleX",scaleX);
        obj.set("scaleY",scaleY);
        canvas.renderAll();
        canvas.trigger("object:modified");
        opearationRecords(recordsParentid, "Image shrink", optstepNum++);
    } else {
        tipShow("Please selecte picture！");
    }
});

$(".diyTip").on("click", "button", function () {
    if ($(this).index() == 0) {
        $(".diyTip").css('display','none');
    } else {
        $(".diyTip").css('display','none');
        $(".become-clearer").trigger("click");
    }
});
/***********Image operate end*****************/

/**********text operate start****************/
//add text to canvas
$("#addText,#addTextA,#addTextB").on("click", function (params) {
    if(productsType=="Tabletop Display" || productsType=="Placemats"){
        if($(this).attr("id")=="addTextB"){
            currentNum=1;
        }else {
            currentNum=0;
        }
    }
    let canvas=allCanvasArr[currentNum].canvas;
    if($(".product-submite-tip").is(":visible")) return;
    let origW=initFontSize*10;
    let color="#000000";
    if(materialProduct && (materialProduct.indexOf("blackPaper")>-1 || (nameType=="groceryBags" && materialProduct.indexOf("black")>-1)) ){
        color="#ffffff";
    }
    let texContent="click on me to modify";
    if(productsType=="Planner"){
        texContent="Add Your Texts Here";
    }
    let textNew = new fabric.Textbox(texContent, {
        width: origW,
        left: 0,
        top: 0,
        fill: color,
        fontSize: initFontSize,
        fontFamily: "Arimo-Regular",
        textAlign: "center",
    });
    textNew.objType = "text";
    let width=defulatW*canvas.width;
    let height=defulatH*canvas.height;
    let left=defulatX*canvas.width;
    let top=defulatY*canvas.height;
    textNew.set("left",left+(width-textNew.width)/2);
    textNew.set("top",top+(height-textNew.height)/2);
    if(windowHV==2){//Vertical adjustment on mobile
        if($(this).attr("id")=="addTextA"){
            textNew.set("top",textNew.top-changeY);
        }else if($(this).attr("id")=="addTextB"){
            textNew.set("top",textNew.top+changeY2);
        }
    }else{//Horizontal adjustment on PC
        if($(this).attr("id")=="addTextA"){
            textNew.set("left",textNew.left-changeX);
        }else if($(this).attr("id")=="addTextB"){
            textNew.set("left",textNew.left+changeX2);
        }
    }
    setObjProPerty(textNew);
    canvas.add(textNew);
    canvas.setActiveObject(textNew);
    canvas.renderAll();
    undoArr.unshift(creatDesin());
    buttonCl();
});

//delete canva obj btn
let deleteBtnSet=function(visible,obj) {
    if(visible){
        if(obj){
            $(".canvas-delet-item").css('display','none');
            $(".canvas-delet-item").css("left",obj.left-$(".canvas-delet-item").width()/2);
            $(".canvas-delet-item").css("top",obj.top-$(".canvas-delet-item").height()/2);
            $(obj.canvas.lowerCanvasEl).parent().find(".canvas-delet-item").css('display','block');
        }
    }else{
        $(".canvas-delet-item").css('display','none');
        $(".align-menu").css("display","none");
    }
    if(productsType=="Planner"){
        let that=allCanvasArr[currentNum];
        updateGuideLineShow(false);
        let toDataURL = that.canvas.toDataURL();
        $(".page-change-canvas li").eq(currentNum).find("img").attr("src",toDataURL);
    }
}

//check obj position
let checkObjPosition=function (obj) {
    if(obj){
        let that=allCanvasArr[currentNum];
        let canvas=that.canvas;
        let limitDistance=2;
        if(that.workAreaWidth){
            let canvasRo=canvas.width/that.workAreaWidth;
            //Reserve 2mm distance
            let limitNum=2;
            //Millimeter to pixel conversion
            limitDistance=canvasRo*limitNum;
        }
        var groupRect = new fabric.Rect({
            opacity: 0,
            visible: false,
            left:0,
            top:0,
            width:that.canvas.width,
            height:that.canvas.height
        })
        that.canvas.add(groupRect);
        if(!obj.intersectsWithObject(groupRect,true,true)){
            if(obj.left<0){
                obj.setLeft(limitDistance);
            }else if(obj.left>that.canFactWidth){
                obj.setLeft(that.canFactWidth-obj.getBoundingRect(true,true).width-limitDistance);
            }
            if(obj.top<0){
                obj.setTop(limitDistance);
            }else if(obj.top>that.canFactHeight){
                obj.setTop(that.canFactHeight-obj.getBoundingRect(true,true).height-limitDistance);
            }
            canvas.renderAll();
        }
        that.canvas.remove(groupRect);
    }
}

//show text tail
let showTextTail = (obj, visible,type) => {
    $(".remove-Bg").removeClass("on");
    $(".become-clearer").removeClass("on");
    if (visible && obj && obj.objType=="text") {
        $(".text-propty").css('display','block');
        if(obj.text=="Add Your Texts Here"){
            $(".text-propty-item .text-content").attr("placeholder",obj.text);
        }else {
            $(".text-propty-item .text-content").val(obj.text);
        }
        $("#font-type-select .type-select .selected").text(obj.fontFamily);
        $("#font-color-select .color-select .selected span:first").css(
            "background-color",
            obj.fill
        );
        $("#font-size-select .size-input").val(obj.fontSize);
        $(".reduce-font-size").removeClass("icon-opacity");
        if(obj.fontSize<=minFontSize){
            $(".reduce-font-size").addClass("icon-opacity");
        }
        if(maxFontSize<=obj.fontSize){
            $(".add-font-size").addClass("icon-opacity");
        }
    } else {
        $(".text-propty").css('display','none');
        if (obj && obj.nocropImg && type!="cleared") {
            $(".remove-Bg").addClass("on");
        }
        if (obj && obj.noclearImg && type!="cleared") {
            $(".become-clearer").addClass("on");
        }
    }
    if(obj){
        $(".canvas-delet-item").css("left",obj.left-$(".canvas-delet-item").width()/2);
        $(".canvas-delet-item").css("top",obj.top-$(".canvas-delet-item").height()/2);
    }
};

//ctrl+z
$(document).keydown(function (e) {
    if($(".paper-handbag-Diy").is(":visible")){
        if(e.ctrlKey  && e.keyCode == 90 && e.target.nodeName!="TEXTAREA" && e.target.nodeName!="INPUT"){
            $(".paper-handbag-Diy .uploadPropTipDiyzButtonPrevious").trigger("click");
        }
    }
})
$(document).on("click",function (e) {
    if($(e.target).parents(".font-style").length==0){
        $(".font-style .selectDrop").css('display','none');
    }
})
// change fontfamily
$("#font-type-select .type-select").on("click", function (params) {
    $(".font-select .color-select .selectDrop").css('display','none');
    if($("#font-type-select .type-select .selectDrop").is(":visible")){
        $("#font-type-select .type-select .selectDrop").css('display','none');
    }else {
        $("#font-type-select .type-select .selectDrop").css('display','block');
    }
});
$("#font-type-select .type-select .selectDrop").on("click","li",function (params) {
    let canvas=allCanvasArr[currentNum].canvas;
    let fontName = $(this).attr("fontname");
    $(".cartreloads").find("p").text("Loading fonts");
    $(".cartreloads").css('display','block');
    let count=0;
    let loadFont=function (fontName) {
        FontDetect.onFontLoaded(fontName, function (font) {
                let obj = canvas.getActiveObject();
                obj.setFontFamily(fontName);
                $("#font-type-select .type-select .selected").text(obj.fontFamily);
                canvas.renderAll();
                canvas.trigger("object:modified");
                $(".font-select .selectDrop").css('display','none');
                $(".cartreloads").css('display','none');
            },
            function (font) {
                count++;
                if(count<5){
                    loadFont(font);
                }else {
                    tipShow('Font loading failed. Please try again');
                    $(".cartreloads").css('display','none');
                }
            }, {
                msTimeout: 5000
            }
        );
    }
    loadFont(fontName);
});
//change color
$("#font-color-select .color-select .selected").on("click", function (params) {
    $("#font-type-select .type-select .selectDrop").css('display','none');
    if($("#font-color-select .color-select .selectDrop").is(":visible")){
        $("#font-color-select .color-select .selectDrop").css('display','none');
    }else {
        $("#font-color-select .color-select .selectDrop").css('display','block');
    }
});
$("#font-color-select .color-select .selectDrop").on("click", ".color-item-box div",function (params) {
    let canvas=allCanvasArr[currentNum].canvas;
    let fillColor = $(this).attr("color-t");
    let obj = canvas.getActiveObject();
    obj.setFill(fillColor);
    $("#font-color-select .color-select .selected span:first").css(
        "background-color",
        obj.fill
    );
    canvas.renderAll();
    canvas.trigger("object:modified");
    $(".font-select .selectDrop").css('display','none');
});

// change font size
$("#font-size-select .size-select .selected").on("click", function (params) {
    $(".font-select .selectDrop").css('display','none');
    $("#font-size-select .size-select .selectDrop").css('display','block');
});
$("#font-size-select .reduce-font-size").on("click",function () {
    let fontSize = Number($("#font-size-select .size-input").val());
    if(isNaN(fontSize)){
        tipShow('Please enter a number');
        return
    }
    fontSize=fontSize-1;
    $(".reduce-font-size,.add-font-size").removeClass("icon-opacity");
    if(fontSize<=minFontSize){
        fontSize=minFontSize;
        $(".reduce-font-size").addClass("icon-opacity");
    }
    if(maxFontSize<=fontSize){
        fontSize=maxFontSize;
        $(".add-font-size").addClass("icon-opacity");
    }
    setFontSize(fontSize);
})
$("#font-size-select .add-font-size").on("click",function () {
    $(".reduce-font-size,.add-font-size").removeClass("icon-opacity");
    let fontSize = Number($("#font-size-select .size-input").val());
    if(isNaN(fontSize)){
        tipShow('Please enter a number');
        return
    }
    fontSize=fontSize+1;
    if(maxFontSize<=fontSize){
        fontSize=maxFontSize;
        $(".add-font-size").addClass("icon-opacity");
    }
    setFontSize(fontSize);
})
$("#font-size-select .size-input").blur(function () {
    $(".reduce-font-size,.add-font-size").removeClass("icon-opacity");
    let fontSize = Number($("#font-size-select .size-input").val());
    if(isNaN(fontSize)){
        tipShow('Please enter a number');
        return
    }
    if(fontSize<=minFontSize){
        fontSize=minFontSize;
        $(".reduce-font-size").addClass("icon-opacity");
    }
    if(maxFontSize<=fontSize){
        fontSize=maxFontSize;
        $(".add-font-size").addClass("icon-opacity");
    }
    setFontSize(fontSize);
})
let setFontSize=function (fontSize) {
    $("#font-size-select .size-input").val(fontSize);
    let canvas=allCanvasArr[currentNum].canvas;
    let obj = canvas.getActiveObject();
    obj.setFontSize(fontSize);
    canvas.renderAll();
    canvas.trigger("object:modified");
    $(".font-select .selectDrop").css('display','none');
}
//change text content
$(".text-propty-item .text-content").on("input propertychange",function (params) {
    let canvas=allCanvasArr[currentNum].canvas;
    let obj = canvas.getActiveObject();
    obj.setText($(this).val());
    canvas.renderAll();
});
$(".text-propty-item .text-content").blur(function (params) {
    undoArr.unshift(creatDesin());
});
/***********text operate end***************/

/**********other operate start**************/
$(".bg-list-items").on("input propertychange",function (e) {
    let colorval=$(e.target).val();
    let canvas=allCanvasArr[currentNum].canvas;
    //removebg
    let obj = canvas._objects.filter(obj => obj.isBG);
    if(obj && obj[0]){
        obj[0].setFill(colorval);
        canvas.renderAll();
    }else {
        $(".cartreloads").find("p").text("change begin...");
        $(".cartreloads").css('display','block');
        $(".cartreloads").find("p").text("change begin...");
        $(".cartreloads").css('display','block');
        let bgShapeObj = new fabric.Rect(); //背景颜色对象
        bgShapeObj.setFill(colorval);
        bgShapeObj.width=canvas.width;
        bgShapeObj.height=canvas.height;
        bgShapeObj.left=0;
        bgShapeObj.top=0;
        bgShapeObj.isBG=true;
        bgShapeObj.objType="shape";
        setObjProPerty(bgShapeObj);
        canvas.add(bgShapeObj);
        canvas.sendToBack(bgShapeObj);
        canvas.renderAll();
        $(".cartreloads").css('display','none');
        deleteBtnSet(false);
    }

})
//change background image
$(".bg-list-items").on("click", ".bg-color", function () {
    let canvas=allCanvasArr[currentNum].canvas;
    //removebg
    let obj = canvas._objects.filter(obj => obj.isBG);
    if(obj && obj[0]){
        canvas.remove(obj[0]);
        canvas.renderAll();
    }
    if($(this).hasClass('active')){
        //cancel selected
        $(this).removeClass("active");
    }else{
        $(".cartreloads").find("p").text("change begin...");
        $(".cartreloads").css('display','block');
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        $(".cartreloads").find("p").text("change begin...");
        $(".cartreloads").css('display','block');
        let colorval = $(this).attr("colorval");
        let bgShapeObj = new fabric.Rect(); //背景颜色对象
        bgShapeObj.setFill(colorval);
        bgShapeObj.width=canvas.width;
        bgShapeObj.height=canvas.height;
        bgShapeObj.left=0;
        bgShapeObj.top=0;
        bgShapeObj.isBG=true;
        bgShapeObj.objType="shape";
        setObjProPerty(bgShapeObj);
        canvas.add(bgShapeObj);
        canvas.sendToBack(bgShapeObj);
        canvas.renderAll();
        $(".cartreloads").css('display','none');
        buttonCl();
        deleteBtnSet(false);
    }

});
//change background image
$(".bg-list-items").on("click", ".bg-item img", function (event) {
    let canvas=allCanvasArr[currentNum].canvas;
    if($(this).parent().hasClass('active')){
        //cancel selected
        $(this).parent().removeClass("active");
        //removebg
        let obj = canvas._objects.filter(obj => obj.isBG);
        if(obj && obj[0]){
            canvas.remove(obj[0]);
            canvas.renderAll();
        }
        if(productsType=="cup"){
            $(".paper-handbag-preview .preview-img").attr("src",imagemodelpath);
        }
    }else{
        $(this).parent().siblings().removeClass("active");
        $(this).parent().addClass("active");
        $(".cartreloads").find("p").text("change begin...");
        $(".cartreloads").css('display','block');
        let imgSrc = $(this).attr("src");
        if($(this).attr("osrc") && $(this).attr("osrc")!=""){
            imgSrc=$(this).attr("osrc");
        }
        if(productsType=="cup" && $(this).attr("modelpath") && $(this).attr("modelpath")!=""){
            let selectImgSrc=$(this).attr("modelpath");
            $(".paper-handbag-preview .preview-img").attr("src",selectImgSrc);
        }
        if (canvas._objects[0] && canvas._objects[0].isBG) {
            canvas.remove(canvas._objects[0]);
        }
        imgSrc=imgSrc.replace("small","normal");
        new fabric.Image.fromURL(imgSrc,function (oImg) {
            oImg.setWidth(canvas.width);
            oImg.setHeight(canvas.height);
            oImg.set("left",0);
            oImg.set("top",0);
            oImg.envent = false;
            oImg.isBG = true;
            oImg.objType = "image";
            setObjProPerty(oImg);
            canvas.add(oImg);
            canvas.sendToBack(oImg);
            canvas.renderAll();
            $(".cartreloads").css('display','none');
            //tipShow("change success");
            undoArr.unshift(creatDesin());
            if(productsType!="bag"){
                buttonCl();
            }
        },{crossOrigin: "anonymous"});
    }

});

let updateImg=function(params) {
    $(".paper-handbag-preview .preview-img").css("background-color","unset");
    var newproductselectfirstchildSizeText=$('.newproductselectfirstchildSize').text()
    if(UploadProductType.UploadProductType.name=='cup'){
        if(newproductselectfirstchildSizeText=='8 oz'){
            $('.paper-handbag-preview .preview-front-model').css('left','22.88%')
            $('.paper-handbag-preview .preview-front-model').css('top','37%')
            $('.paper-handbag-preview .preview-front-model').css('width','22.7%')
            $('.preview-front-model-right').css('top','37%')
            $('.preview-front-model-right').css('right','23%')
            $('.preview-front-model-right').css('width','22.7%')
        }else{
            $('.paper-handbag-preview .preview-front-model').css('left','20.4%')
            $('.paper-handbag-preview .preview-front-model').css('top','29.8%')
            $('.paper-handbag-preview .preview-front-model').css('width','22.5%')
            $('.preview-front-model-right').css('top','29.8%')
            $('.preview-front-model-right').css('right','18.7%')
            $('.preview-front-model-right').css('width','22.5%')
        }
    }else if(UploadProductType.UploadProductType.name=='handbag'){
        $('.paper-handbag-preview .preview-front-model').addClass('preview-front-modelbags')
        $('.preview-front-model-right').addClass('preview-front-model-rightbags')
        if(aspectRatio<1){
            if(windowHV==2){
                $('.preview-front-modelbags').css('top','31%')
                $('.preview-front-modelbags').css('left','21.3%')
                $('.preview-front-modelbags').css('width','21.5%')
                $('.preview-front-modelbags').css('height','44%')
                $('.preview-front-modelbags').css('transform','perspective(552px) rotateY(26deg) rotateX(1deg) rotateZ(363deg) skew(5deg, -7deg)')
                $('.preview-front-model-rightbags').css('top','31%')
                $('.preview-front-model-rightbags').css('right','23.8%')
                $('.preview-front-model-rightbags').css('width','25%')
                $('.preview-front-model-rightbags').css('height','46%')
                $('.preview-front-model-rightbags').css('transform','perspective(558px) rotateY(331deg) rotateX(4deg) rotateZ(1deg) skew(-1deg, 2deg)')
            }else{
                $('.preview-front-modelbags').css('top','31%')
                $('.preview-front-modelbags').css('left','22%')
                $('.preview-front-modelbags').css('width','21.5%')
                $('.preview-front-modelbags').css('height','44%')
                $('.preview-front-modelbags').css('transform','perspective(552px) rotateY(22deg) rotateX(12deg) rotateZ(365deg) skew(5deg, -7deg)')
                $('.preview-front-model-rightbags').css('top','30.5%')
                $('.preview-front-model-rightbags').css('right','25%')
                $('.preview-front-model-rightbags').css('width','22.5%')
                $('.preview-front-model-rightbags').css('height','48%')
                $('.preview-front-model-rightbags').css('transform','perspective(590px) rotateY(341deg) rotateX(13deg) rotateZ(-8deg) skew(-8deg, 11deg)')
            }

        }else if(aspectRatio==1){
            if(windowHV==2){
                $('.preview-front-modelbags').css('top','36%')
                $('.preview-front-modelbags').css('left','20%')
                $('.preview-front-modelbags').css('width','24.2%')
                $('.preview-front-modelbags').css('height','39%')
                $('.preview-front-modelbags').css('transform','perspective(552px) rotateY(26deg) rotateX(1deg) rotateZ(363deg) skew(5deg, -7deg)')
                $('.preview-front-model-rightbags').css('top','36.1%')
                $('.preview-front-model-rightbags').css('right','23%')
                $('.preview-front-model-rightbags').css('width','27%')
                $('.preview-front-model-rightbags').css('height','42%')
                $('.preview-front-model-rightbags').css('transform','perspective(558px) rotateY(331deg) rotateX(4deg) rotateZ(1deg) skew(-1deg, 2deg)')
            }else{
                $('.preview-front-modelbags').css('top','35%')
                $('.preview-front-modelbags').css('left','22%')
                $('.preview-front-modelbags').css('width','21.5%')
                $('.preview-front-modelbags').css('height','41%')
                $('.preview-front-modelbags').css('transform','perspective(552px) rotateY(22deg) rotateX(12deg) rotateZ(365deg) skew(5deg, -7deg)')
                $('.preview-front-model-rightbags').css('top','34%')
                $('.preview-front-model-rightbags').css('right','25%')
                $('.preview-front-model-rightbags').css('width','22.5%')
                $('.preview-front-model-rightbags').css('height','44%')
                $('.preview-front-model-rightbags').css('transform','perspective(590px) rotateY(341deg) rotateX(13deg) rotateZ(-8deg) skew(-8deg, 11deg)')
            }
        }else if(aspectRatio>1){
            if(windowHV==2){
                $('.preview-front-modelbags').css('top','42%')
                $('.preview-front-modelbags').css('left','18.5%')
                $('.preview-front-modelbags').css('width','25%')
                $('.preview-front-modelbags').css('height','33%')
                $('.preview-front-modelbags').css('transform','perspective(552px) rotateY(26deg) rotateX(1deg) rotateZ(363deg) skew(5deg, -7deg)')
                $('.preview-front-model-rightbags').css('top','42.1%')
                $('.preview-front-model-rightbags').css('right','21%')
                $('.preview-front-model-rightbags').css('width','28%')
                $('.preview-front-model-rightbags').css('height','36%')
                $('.preview-front-model-rightbags').css('transform','perspective(558px) rotateY(331deg) rotateX(4deg) rotateZ(1deg) skew(-1deg, 2deg)')
            }else{
                $('.preview-front-modelbags').css('top','41%')
                $('.preview-front-modelbags').css('left','19.5%')
                $('.preview-front-modelbags').css('width','24.5%')
                $('.preview-front-modelbags').css('height','36%')
                $('.preview-front-modelbags').css('transform','perspective(552px) rotateY(22deg) rotateX(12deg) rotateZ(365deg) skew(5deg, -7deg)')
                $('.preview-front-model-rightbags').css('top','41%')
                $('.preview-front-model-rightbags').css('right','22.5%')
                $('.preview-front-model-rightbags').css('width','26%')
                $('.preview-front-model-rightbags').css('height','39%')
                $('.preview-front-model-rightbags').css('transform','perspective(590px) rotateY(341deg) rotateX(13deg) rotateZ(-8deg) skew(-8deg, 11deg)')
            }
        }
    }else if(UploadProductType.UploadProductType.name=='plasticppcups'){
        if(newproductselectfirstchildSizeText=='17 oz'){
            $('.paper-handbag-preview .preview-front-model').css('left','21.4%')
            $('.paper-handbag-preview .preview-front-model').css('top','40%')
            $('.paper-handbag-preview .preview-front-model').css('width','21.5%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('top','40%')
            $('.preview-front-model-right').css('right','18.5%')
            $('.preview-front-model-right').css('width','21.5%')
            $('.preview-front-model-right').css('height','auto')
            if(materialProduct == "clear"){
                $('.paper-handbag-preview .preview-front-model').css('left','20.9%')
                $('.preview-front-model-right').css('right','18.9%')
                $('.preview-front-model-right').css('width','21.6%')
            }
        }else{
            $('.paper-handbag-preview .preview-front-model').css('left','22%')
            $('.paper-handbag-preview .preview-front-model').css('top','39%')
            $('.paper-handbag-preview .preview-front-model').css('width','18.5%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('top','39%')
            $('.preview-front-model-right').css('right','21.5%')
            $('.preview-front-model-right').css('width','18.5%')
            $('.preview-front-model-right').css('height','auto')
        }
    }else if(UploadProductType.UploadProductType.name.indexOf('plasticpetcups')>=0){
        if(UploadProductType.UploadProductType.name.indexOf('12oz')>0){
            $('.paper-handbag-preview .preview-front-model').css('left','21%')
            $('.paper-handbag-preview .preview-front-model').css('top','49%')
            $('.paper-handbag-preview .preview-front-model').css('width','21%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('right','19.8%')
            $('.preview-front-model-right').css('top','49%')
            $('.preview-front-model-right').css('width','21%')
            $('.preview-front-model-right').css('height','auto')
        }else{
            $('.paper-handbag-preview .preview-front-model').css('left','19%')
            $('.paper-handbag-preview .preview-front-model').css('top','43%')
            $('.paper-handbag-preview .preview-front-model').css('width','22%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('right','20.5%')
            $('.preview-front-model-right').css('top','43%')
            $('.preview-front-model-right').css('width','22%')
            $('.preview-front-model-right').css('height','auto')
        }
    }else if(nameType=="bowl"){
        if(newproductselectfirstchildSizeText=='12 oz'){
            $('.paper-handbag-preview .preview-front-model').css('left','12.4%')
            $('.paper-handbag-preview .preview-front-model').css('top','43%')
            $('.paper-handbag-preview .preview-front-model').css('width','33.5%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('right','9.5%')
            $('.preview-front-model-right').css('top','43%')
            $('.preview-front-model-right').css('width','33.5%')
            $('.preview-front-model-right').css('height','auto')
        }else if(newproductselectfirstchildSizeText=='16 oz'){
            $('.paper-handbag-preview .preview-front-model').css('left','11.2%')
            $('.paper-handbag-preview .preview-front-model').css('top','43.2%')
            $('.paper-handbag-preview .preview-front-model').css('width','35.2%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('right','8.9%')
            $('.preview-front-model-right').css('top','43.2%')
            $('.preview-front-model-right').css('width','35.2%')
            $('.preview-front-model-right').css('height','auto')
        }else if(newproductselectfirstchildSizeText=='22 oz'){
            $('.paper-handbag-preview .preview-front-model').css('left','12.1%')
            $('.paper-handbag-preview .preview-front-model').css('top','38.2%')
            $('.paper-handbag-preview .preview-front-model').css('width','33.5%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('right','10.5%')
            $('.preview-front-model-right').css('top','38.2%')
            $('.preview-front-model-right').css('width','33.5%')
            $('.preview-front-model-right').css('height','auto')
        }else{
            $('.paper-handbag-preview .preview-front-model').css('left','13.3%')
            $('.paper-handbag-preview .preview-front-model').css('top','36%')
            $('.paper-handbag-preview .preview-front-model').css('width','33.5%')
            $('.paper-handbag-preview .preview-front-model').css('height','auto')
            $('.preview-front-model-right').css('right','10%')
            $('.preview-front-model-right').css('top','36%')
            $('.preview-front-model-right').css('width','33.5%')
            $('.preview-front-model-right').css('height','auto')
        }

    }else if(nameType=="heldBag"){
        $('.paper-handbag-preview .preview-front-model').addClass('preview-front-modelbags')
        $('.preview-front-model-right').addClass('preview-front-model-rightbags')
        if(aspectRatio<1){
            $('.preview-front-modelbags').css('top','21%')
            $('.preview-front-modelbags').css('left','20.7%')
            $('.preview-front-modelbags').css('width','20%')
            $('.preview-front-modelbags').css('height','auto')
            $('.preview-front-modelbags').css('transform','perspective(589px) rotateY(349deg) rotateX(-2deg) rotateZ(-9deg) skew(-11deg, 12deg)')
            $('.preview-front-model-rightbags').css('top','21%')
            $('.preview-front-model-rightbags').css('right','27%')
            $('.preview-front-model-rightbags').css('width','20%')
            $('.preview-front-model-rightbags').css('height','auto')
            $('.preview-front-model-rightbags').css('transform','perspective(589px) rotateY(349deg) rotateX(-2.5deg) rotateZ(-9deg) skew(-10.5deg, 12deg)')
        }
    }else if(nameType=="toteBag"){
        $('.paper-handbag-preview .preview-front-model').addClass('preview-front-modelbags')
        $('.preview-front-model-right').addClass('preview-front-model-rightbags')
        if(aspectRatio<=1){
            $('.preview-front-modelbags').css('top','34%')
            $('.preview-front-modelbags').css('left','16%')
            $('.preview-front-modelbags').css('width','25%')
            $('.preview-front-modelbags').css('height','auto')
            $('.preview-front-modelbags').css('transform','perspective(590px) rotateY(341deg) rotateX(10deg) rotateZ(-15deg) skew(-11deg, 13deg)')
            $('.preview-front-model-rightbags').css('top','30.5%')
            $('.preview-front-model-rightbags').css('right','24.5%')
            $('.preview-front-model-rightbags').css('width','26.5%')
            $('.preview-front-model-rightbags').css('height','auto')
            $('.preview-front-model-rightbags').css('transform','perspective(590px) rotateY(341deg) rotateX(10deg) rotateZ(-15deg) skew(-11deg, 13deg)')
        }else if(aspectRatio>1){
            $('.preview-front-modelbags').css('top','33%')
            $('.preview-front-modelbags').css('left','18%')
            $('.preview-front-modelbags').css('width','32%')
            $('.preview-front-modelbags').css('height','auto')
            $('.preview-front-modelbags').css('transform','perspective(552px) rotateY(22deg) rotateX(-9deg) rotateZ(352deg) skew(0deg, -7deg)')
            $('.preview-front-model-rightbags').css('top','35%')
            $('.preview-front-model-rightbags').css('right','8.5%')
            $('.preview-front-model-rightbags').css('width','32%')
            $('.preview-front-model-rightbags').css('height','auto')
            $('.preview-front-model-rightbags').css('transform','perspective(552px) rotateY(22deg) rotateX(-9deg) rotateZ(352deg) skew(0deg, -7deg)')
        }
    }else if(nameType=="flatBag"){
        $('.paper-handbag-preview .preview-front-model').addClass('preview-front-modelbags')
        $('.preview-front-model-right').addClass('preview-front-model-rightbags')
        if(sizeArrWGH[0].indexOf("A")>=0){
            $('.preview-front-modelbags').css('top','31%')
            $('.preview-front-modelbags').css('left','10.7%')
            $('.preview-front-modelbags').css('width','23.9%')
            $('.preview-front-modelbags').css('height','auto')
            $('.preview-front-modelbags').css('transform','perspective(589px) rotateY(349deg) rotateX(-4deg) rotateZ(3deg) skew(1deg, 12deg)')
            $('.preview-front-model-rightbags').css('top','31%')
            $('.preview-front-model-rightbags').css('right','19.8%')
            $('.preview-front-model-rightbags').css('width','23.8%')
            $('.preview-front-model-rightbags').css('height','auto')
            $('.preview-front-model-rightbags').css('transform','perspective(589px) rotateY(349deg) rotateX(-1deg) rotateZ(3deg) skew(1deg, 11deg)')
        }else if(sizeArrWGH[0].indexOf("B")>=0 || sizeArrWGH[0].indexOf("C")>=0){
            $('.preview-front-modelbags').css('top','31%')
            $('.preview-front-modelbags').css('left','9.9%')
            $('.preview-front-modelbags').css('width','27.2%')
            $('.preview-front-modelbags').css('height','auto')
            $('.preview-front-modelbags').css('transform','perspective(611px) rotateY(346deg) rotateX(1deg) rotateZ(0deg) skew(-2deg, 12deg)')
            $('.preview-front-model-rightbags').css('top','31%')
            $('.preview-front-model-rightbags').css('right','18.8%')
            $('.preview-front-model-rightbags').css('width','27.2%')
            $('.preview-front-model-rightbags').css('height','auto')
            $('.preview-front-model-rightbags').css('transform','perspective(589px) rotateY(355deg) rotateX(3deg) rotateZ(2deg) skew(-1deg, 12deg)')
        }else if(sizeArrWGH[0].indexOf("D")>=0){
            $('.preview-front-modelbags').css('top','32.5%')
            $('.preview-front-modelbags').css('left','8.6%')
            $('.preview-front-modelbags').css('width','30.4%')
            $('.preview-front-modelbags').css('height','auto')
            $('.preview-front-modelbags').css('transform','perspective(611px) rotateY(350deg) rotateX(2deg) rotateZ(-2deg) skew(-5deg, 12deg)')
            $('.preview-front-model-rightbags').css('top','35%')
            $('.preview-front-model-rightbags').css('right','16.8%')
            $('.preview-front-model-rightbags').css('width','30.5%')
            $('.preview-front-model-rightbags').css('height','auto')
            $('.preview-front-model-rightbags').css('transform','perspective(589px) rotateY(355deg) rotateX(3deg) rotateZ(2deg) skew(-1deg, 8deg)')
        }
    }else if(nameType=="ribbonBag"){
        $('.paper-handbag-preview .preview-front-model').addClass('preview-front-modelbags')
        $('.preview-front-model-right').addClass('preview-front-model-rightbags')
        if(aspectRatio<1){
            $('.preview-front-modelbags').css('top','27.5%');
            $('.preview-front-modelbags').css('left','11.9%');
            $('.preview-front-modelbags').css('width','33.2%');
            $('.preview-front-modelbags').css('height','61%');
            $('.preview-front-modelbags').css('transform','unset');
            $('.preview-front-model-rightbags').css('top','27.5%');
            $('.preview-front-model-rightbags').css('right','11.2%');
            $('.preview-front-model-rightbags').css('width','33.2%');
            $('.preview-front-model-rightbags').css('height','61%');
            $('.preview-front-model-rightbags').css('transform','unset');
        }else {
            $('.preview-front-modelbags').css('top','35%')
            $('.preview-front-modelbags').css('left','8.5%')
            $('.preview-front-modelbags').css('width','38.3%')
            $('.preview-front-modelbags').css('height','42%')
            $('.preview-front-modelbags').css('transform','unset')
            $('.preview-front-model-rightbags').css('top','35%')
            $('.preview-front-model-rightbags').css('right','7%')
            $('.preview-front-model-rightbags').css('width','38.3%')
            $('.preview-front-model-rightbags').css('height','42%')
            $('.preview-front-model-rightbags').css('transform','unset')
        }
    }else if(nameType=="groceryBags"){
        $('.paper-handbag-preview .preview-front-model').addClass('preview-front-modelbags')
        $('.preview-front-model-right').addClass('preview-front-model-rightbags')
        $('.preview-front-model-rightbags').css('height','auto');
        $('.preview-front-model-rightbags').css('transform','unset');
        if(sizeArrWGH[0] == 8 && sizeArrWGH[1] == 5 && sizeArrWGH[2] == 10){
            $('.preview-front-modelbags').css('top','41.5%');
            $('.preview-front-modelbags').css('left','22.1%');
            $('.preview-front-modelbags').css('width','22.5%');
            $('.preview-front-modelbags').css('height','auto');
            $('.preview-front-modelbags').css('transform','unset');
            $('.preview-front-model-rightbags').css('top','41.5%');
            $('.preview-front-model-rightbags').css('right','21%');
            $('.preview-front-model-rightbags').css('width','22.5%');
        }else if(sizeArrWGH[0] == 9 && sizeArrWGH[1] == 6 && sizeArrWGH[2] == 10){
            $('.preview-front-modelbags').css('top','39%');
            $('.preview-front-modelbags').css('left','17.3%');
            $('.preview-front-modelbags').css('width','25.5%');
            $('.preview-front-modelbags').css('height','auto');
            $('.preview-front-modelbags').css('transform','unset');
            $('.preview-front-model-rightbags').css('top','39%');
            $('.preview-front-model-rightbags').css('right','17.9%');
            $('.preview-front-model-rightbags').css('width','25.5%');
        }else if(sizeArrWGH[0] == 10 && sizeArrWGH[1] == 7 && sizeArrWGH[2] == 10){
            $('.preview-front-modelbags').css('top','35%');
            $('.preview-front-modelbags').css('left','27%');
            $('.preview-front-modelbags').css('width','22%');
            $('.preview-front-modelbags').css('height','41%');
            $('.preview-front-modelbags').css('transform','perspective(550px) rotateY(13deg) rotateX(1deg) rotate(356deg) skew(-2deg, -1deg)');
            $('.preview-front-model-rightbags').css('top','40.5%');
            $('.preview-front-model-rightbags').css('right','25.4%');
            $('.preview-front-model-rightbags').css('width','22%');
            $('.preview-front-model-rightbags').css('height','41%');
            $('.preview-front-model-rightbags').css('transform','perspective(550px) rotateY(345deg) rotateX(5deg) rotate(1deg) skew(0deg,5deg)');
        }else if(sizeArrWGH[0] == 12 && sizeArrWGH[1] == 4 && sizeArrWGH[2] == 15){
            $('.preview-front-modelbags').css('top','28%');
            $('.preview-front-modelbags').css('left','23%');
            $('.preview-front-modelbags').css('width','23%');
            $('.preview-front-modelbags').css('height','53%');
            $('.preview-front-modelbags').css('transform','perspective(550px) rotateY(13deg) rotateX(-1deg) rotate(356deg) skew(-2.5deg, -1deg)');
            $('.preview-front-model-rightbags').css('top','33%');
            $('.preview-front-model-rightbags').css('right','25%');
            $('.preview-front-model-rightbags').css('width','22%');
            $('.preview-front-model-rightbags').css('height','53%');
            $('.preview-front-model-rightbags').css('transform','perspective(550px) rotateY(348deg) rotateX(9deg) rotate(2deg) skew(3deg, 4deg)');
        }
    }else if(nameType=="insulatedCoolerBags"){
        if(sizeArrWGH[2]/sizeArrWGH[0]>2){
            $(".paper-handbag-preview-preview .preview-front-model").css('left','25.5%');
            $(".paper-handbag-preview-preview .preview-front-model").css('top','28.6%');
            $(".paper-handbag-preview-preview .preview-front-model").css('width','17%');
            $(".paper-handbag-preview-preview .preview-front-model").css('height','auto');

            $(".paper-handbag-preview-preview .preview-front-model-right").css('right','25%');
            $(".paper-handbag-preview-preview .preview-front-model-right").css('top','28.6%');
            $(".paper-handbag-preview-preview .preview-front-model-right").css('width','17%');
            $(".paper-handbag-preview-preview .preview-front-model-right").css('height','auto');
        }else if(sizeArrWGH[2]/sizeArrWGH[0]>1){
            $(".paper-handbag-preview-preview .preview-front-model").css('height','auto');
            $(".paper-handbag-preview-preview .preview-front-model").css("top","29.7%");
            $(".paper-handbag-preview-preview .preview-front-model").css("width","32.1%");
            $(".paper-handbag-preview-preview .preview-front-model").css("left","12%");

            $(".paper-handbag-preview-preview .preview-front-model-right").css('height','auto');
            $(".paper-handbag-preview-preview .preview-front-model-right").css("top","29.7%");
            $(".paper-handbag-preview-preview .preview-front-model-right").css("width","32.1%");
            $(".paper-handbag-preview-preview .preview-front-model-right").css("right","12%");
        }else if(sizeArrWGH[0] ==sizeArrWGH[2]){
            $(".paper-handbag-preview-preview .preview-front-model").css('height','auto');
            $(".paper-handbag-preview-preview .preview-front-model").css("top","35.7%");
            $(".paper-handbag-preview-preview .preview-front-model").css("width","33.3%");
            $(".paper-handbag-preview-preview .preview-front-model").css("left","10.8%");

            $(".paper-handbag-preview-preview .preview-front-model-right").css('height','auto');
            $(".paper-handbag-preview-preview .preview-front-model-right").css("top","35.7%");
            $(".paper-handbag-preview-preview .preview-front-model-right").css("width","33.3%");
            $(".paper-handbag-preview-preview .preview-front-model-right").css("right","10.8%");
        }
    }else if(nameType=="Browntotebag"){
        $('.paper-handbag-preview .preview-front-model').addClass('preview-front-modelbags')
        $('.preview-front-model-right').addClass('preview-front-model-rightbags')
        $('.preview-front-model-rightbags').css('height','auto');
        $('.preview-front-modelbags').css('height','auto');
        if(newproductselectfirstchildSizeText.indexOf("A")>=0){
            $('.preview-front-modelbags').css('top','32.8%');
            $('.preview-front-modelbags').css('left','21.85%');
            $('.preview-front-modelbags').css('width','24%');
            $('.preview-front-modelbags').css('transform','unset');
            $('.preview-front-model-rightbags').css('top','32.8%');
            $('.preview-front-model-rightbags').css('right','20.45%');
            $('.preview-front-model-rightbags').css('width','24%');
            $('.preview-front-model-rightbags').css('transform','unset');
        }else if(newproductselectfirstchildSizeText.indexOf("B")>=0){
            $('.preview-front-modelbags').css('top','25%');
            $('.preview-front-modelbags').css('left','20.3%');
            $('.preview-front-modelbags').css('width','25.5%');
            $('.preview-front-modelbags').css('height','56.5%');
            $('.preview-front-modelbags').css('transform','perspective(530px) rotateY(10deg) rotateX(4deg) rotate(1deg) skew(4deg,-5deg)');
            $('.preview-front-model-rightbags').css('top','25%');
            $('.preview-front-model-rightbags').css('right','12.5%');
            $('.preview-front-model-rightbags').css('width','25%');
            $('.preview-front-model-rightbags').css('height','56.5%');
            $('.preview-front-model-rightbags').css('transform','perspective(530px) rotateY(10deg) rotateX(4deg) rotate(1deg) skew(4deg,-5deg)');
        }else if(newproductselectfirstchildSizeText.indexOf("C")>=0){
            $('.preview-front-modelbags').css('top','25%');
            $('.preview-front-modelbags').css('left','20.3%');
            $('.preview-front-modelbags').css('width','25.5%');
            $('.preview-front-modelbags').css('height','56.5%');
            $('.preview-front-modelbags').css('transform','perspective(530px) rotateY(10deg) rotateX(4deg) rotate(1deg) skew(4deg,-5deg)');
            $('.preview-front-model-rightbags').css('top','25%');
            $('.preview-front-model-rightbags').css('right','12.5%');
            $('.preview-front-model-rightbags').css('width','25%');
            $('.preview-front-model-rightbags').css('height','56.5%');
            $('.preview-front-model-rightbags').css('transform','perspective(530px) rotateY(10deg) rotateX(4deg) rotate(1deg) skew(4deg,-5deg)');
        }else if(newproductselectfirstchildSizeText.indexOf("D")>=0){
            $('.preview-front-modelbags').css('top','25%');
            $('.preview-front-modelbags').css('left','20.3%');
            $('.preview-front-modelbags').css('width','25.5%');
            $('.preview-front-modelbags').css('height','56.5%');
            $('.preview-front-modelbags').css('transform','perspective(530px) rotateY(10deg) rotateX(4deg) rotate(1deg) skew(4deg,-5deg)');
            $('.preview-front-model-rightbags').css('top','25%');
            $('.preview-front-model-rightbags').css('right','12.5%');
            $('.preview-front-model-rightbags').css('width','25%');
            $('.preview-front-model-rightbags').css('height','56.5%');
            $('.preview-front-model-rightbags').css('transform','perspective(530px) rotateY(10deg) rotateX(4deg) rotate(1deg) skew(4deg,-5deg)');
        }else if(newproductselectfirstchildSizeText.indexOf("E")>=0){
            $('.preview-front-modelbags').css('top','21%');
            $('.preview-front-modelbags').css('left','23.3');
            $('.preview-front-modelbags').css('width','20.5%');
            $('.preview-front-modelbags').css('height','66.5%');
            $('.preview-front-modelbags').css('transform','perspective(530px) rotateY(8deg) rotateX(3deg) rotate(1deg) skew(4deg,-7deg)');
            $('.preview-front-model-rightbags').css('top','21%');
            $('.preview-front-model-rightbags').css('right','19.5%');
            $('.preview-front-model-rightbags').css('width','20.5%');
            $('.preview-front-model-rightbags').css('height','66.5%');
            $('.preview-front-model-rightbags').css('transform','perspective(530px) rotateY(8deg) rotateX(3deg) rotate(1deg) skew(4deg,-7deg)');
        }

    }else if(newProduct.indexOf(productsType)>-1){
        setTimeout(function () {
            let allW=$(".paper-handbag-preview-preview .preview-img").width();
            $(".paper-handbag-preview-preview .preview-front-model").css("width","unset");
            if(productsType=="Posters"){
                $(".paper-handbag-preview-preview .preview-front-model").css("max-height","50%");
                $(".paper-handbag-preview-preview .preview-front-model").css("max-width","40%");
                let previeW=$(".paper-handbag-preview-preview .preview-front-model").width();
                $(".paper-handbag-preview-preview .preview-front-model").css("top","23%");
                $(".paper-handbag-preview-preview .preview-front-model").css("left",parseInt((allW-previeW)/2/allW*100)+"%");
            }else if(productsType=="vinylbanner"){
                let canvas=allCanvasArr[currentNum].canvas;
                let roWh=canvas.width/canvas.height;
                if(roWh>1.2){//H
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","60%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("height","auto");
                    $(".paper-handbag-preview-preview .preview-front-model").css("top","22%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("left","24%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("transform","perspective(591px) rotateY(11deg) rotateX(0deg) rotateZ(-9deg) skew(-9deg, 10deg)");
                }else if(0.8<roWh && roWh<=1.2){//R
                    $(".paper-handbag-preview-preview .preview-front-model").css("height","54%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("top","19%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","36%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("left","21%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("transform","unset");
                }else {//V
                    $(".paper-handbag-preview-preview .preview-front-model").css("height","55%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("top","25%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","auto");
                    let previeW=$(".paper-handbag-preview-preview .preview-front-model").width();
                    $(".paper-handbag-preview-preview .preview-front-model").css("left",parseInt((allW-previeW)/2/allW*100)+"%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("transform","perspective(591px) rotateY(-26deg) rotateX(1deg) rotateZ(6deg) skew(7deg, -12deg)");
                }
            }else if(productsType=="Retractable Banners"){
                $(".paper-handbag-preview-preview .preview-front-model").css("height","49%");
                $(".paper-handbag-preview-preview .preview-front-model").css("top","25%");
                $(".paper-handbag-preview-preview .preview-front-model").css("width","17%");
                $(".paper-handbag-preview-preview .preview-front-model").css("left","30%");
                $(".paper-handbag-preview-preview .preview-front-model").css("transform","perspective(591px) rotateY(-8deg) rotateX(-5deg) rotateZ(0deg) skew(0deg, 12deg)");

                $(".paper-handbag-preview-preview .preview-front-model-right").css("left","55%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("height","50%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("top","21%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("width","17.5%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("transform","perspective(591px) rotateY(-13deg) rotateX(-5deg) rotateZ(1deg) skew(0deg, 12deg)");
            }else if(productsType=="Tabletop Display"){
                $(".paper-handbag-preview .preview-img").css("background-color","#f0f0f0");
                $(".paper-handbag-preview-preview .preview-front-model").css("height","59%");
                $(".paper-handbag-preview-preview .preview-front-model").css("top","20%");
                $(".paper-handbag-preview-preview .preview-front-model").css("width","26%");
                $(".paper-handbag-preview-preview .preview-front-model").css("left","17.5%");
                $(".paper-handbag-preview-preview .preview-front-model").css("transform","perspective(591px) rotateY(5deg) rotateX(0deg) rotateZ(2deg) skew(2deg, -3deg)");

                $(".paper-handbag-preview-preview .preview-front-model-right").css("right","18.5%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("height","59%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("top","20%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("width","26%");
                $(".paper-handbag-preview-preview .preview-front-model-right").css("transform","perspective(591px) rotateY(-7deg) rotateX(1deg) rotateZ(2deg) skew(2deg, -1deg)");
            }else if(productsType=="Puzzles"){
                $(".paper-handbag-preview .preview-model").addClass("preview-model-puzz");
                if(aspectRatio<1){
                    $(".paper-handbag-preview-preview .preview-front-model").css("height","100%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","unset");
                }else {
                    $(".paper-handbag-preview-preview .preview-front-model").css("height","auto");
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","80%");
                }
                $(".paper-handbag-preview .preview-img").css("width",$(".paper-handbag-preview-preview .preview-front-model").width());
                $(".paper-handbag-preview .preview-img").css("height",$(".paper-handbag-preview-preview .preview-front-model").height());
                $(".paper-handbag-preview .preview-img").css("display","block");
            }else if(productsType == "XBanners"){
                if(productSize == "23*63"){
                    $(".paper-handbag-preview-preview .preview-front-model").css("height",'auto');
                    $(".paper-handbag-preview-preview .preview-front-model").css("top","5%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","22.3%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("left","38.6%");
                }else{
                    $(".paper-handbag-preview-preview .preview-front-model").css("height",'89.5%');
                    $(".paper-handbag-preview-preview .preview-front-model").css("top","4.8%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","26.2%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("left","36.8%");
                }
            }else if(productsType == "Flyers"){
                let canvas=allCanvasArr[currentNum].canvas;
                if(canvas.width>canvas.height){
                    if((canvas.width/canvas.height)>2){
                        $(".paper-handbag-preview-preview .preview-front-model").css("top","35%");
                        $(".paper-handbag-preview-preview .preview-front-model-right").css("top","35%");
                    }else if((canvas.width/canvas.height)>1){
                        $(".paper-handbag-preview-preview .preview-front-model").css("top","30%");
                        $(".paper-handbag-preview-preview .preview-front-model-right").css("top","30%");
                    }else {
                        $(".paper-handbag-preview-preview .preview-front-model").css("top","25%");
                        $(".paper-handbag-preview-preview .preview-front-model-right").css("top","25%");
                    }
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","35%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("left","10%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("height","auto");
                    $(".paper-handbag-preview-preview .preview-front-model-right").css("width","35%");
                    $(".paper-handbag-preview-preview .preview-front-model-right").css("right","10%");
                    $(".paper-handbag-preview-preview .preview-front-model-right").css("height","auto");
                }else{
                    if((canvas.width/canvas.height)>2){
                        $(".paper-handbag-preview-preview .preview-front-model").css("left","20%");
                        $(".paper-handbag-preview-preview .preview-front-model-right").css("right","20%");
                    }else if((canvas.width/canvas.height)>1){
                        $(".paper-handbag-preview-preview .preview-front-model").css("left","15%");
                        $(".paper-handbag-preview-preview .preview-front-model-right").css("right","15%");
                    }else{
                        $(".paper-handbag-preview-preview .preview-front-model").css("left","10%");
                        $(".paper-handbag-preview-preview .preview-front-model-right").css("right","10%");
                    }
                    $(".paper-handbag-preview-preview .preview-front-model").css("height","80%");
                    $(".paper-handbag-preview-preview .preview-front-model").css("width","auto");
                    $(".paper-handbag-preview-preview .preview-front-model").css("top","10%");
                    $(".paper-handbag-preview-preview .preview-front-model-right").css("height","80%");
                    $(".paper-handbag-preview-preview .preview-front-model-right").css("width","auto");
                    $(".paper-handbag-preview-preview .preview-front-model-right").css("top","10%");
                }                
            }
        })
    }else if(materialProduct=="hard" || materialProduct=="soft"){
        $(".paper-handbag-preview-preview .preview-front-model").css("height","73%");
        $(".paper-handbag-preview-preview .preview-front-model").css("top","14%");
        $(".paper-handbag-preview-preview .preview-front-model").css("width","36.5%");
        $(".paper-handbag-preview-preview .preview-front-model").css("left","10.2%");
        $(".paper-handbag-preview-preview .preview-front-model").css("z-index","-1");

        $(".paper-handbag-preview-preview .preview-front-model-right").css("right","10%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("height","73%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("top","14%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("width","36.5%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("z-index","-1");
    }else if(materialProduct=="spiral"){
        $(".paper-handbag-preview-preview .preview-front-model").css("height","71.3%");
        $(".paper-handbag-preview-preview .preview-front-model").css("top","15.5%");
        $(".paper-handbag-preview-preview .preview-front-model").css("width","35.3%");
        $(".paper-handbag-preview-preview .preview-front-model").css("left","11.9%");
        $(".paper-handbag-preview-preview .preview-front-model").css("z-index","-1");

        $(".paper-handbag-preview-preview .preview-front-model-right").css("right","11.8%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("height","71.3%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("top","15.5%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("width","35.3%");
        $(".paper-handbag-preview-preview .preview-front-model-right").css("z-index","-1");
    }
}
// Design Content Preview
$(".img-btn-box .preview").on("click",function(params) {
    let canvas=allCanvasArr[currentNum].canvas;
    setCanvasSize(4);
    if(canvas.overlayImage)canvas.overlayImage.setVisible(false);
    updateGuideLineShow(false);
    if(newProduct.indexOf(productsType)<0 && productsType!="Planner" && nameType!="ribbonBag" && nameType!="insulatedCoolerBags"){
        canvas.setBackgroundColor("rgba(0,0,0,0)");
        if(canvas._objects[0] && canvas._objects[0].isBG)canvas._objects[0].setVisible(false);
    }
    canvas.renderAll();
    let previewPath=canvas.toDataURL({format: 'png',left:defulatX*canvas.width,top:defulatY*canvas.height,width:defulatW*canvas.width,height:defulatH*canvas.height});
    let previewPath2;
    if(oneOrTwoSide==1){
        if(productsType=="cup" || productsType=="bag"){
            previewPath=canvas.toDataURL({format: 'png',left:defulatX1*canvas.width,top:defulatY1*canvas.height,width:defulatW*canvas.width,height:defulatH*canvas.height});
            previewPath2=canvas.toDataURL({format: 'png',left:defulatX2*canvas.width,top:defulatY2*canvas.height,width:defulatW*canvas.width,height:defulatH*canvas.height});
        }else if(productsType=="Tabletop Display" || productsType=="Placemats"){
            previewPath=allCanvasArr[0].canvas.toDataURL({format: 'png',left:defulatX1*canvas.width,top:defulatY1*canvas.height,width:defulatW*canvas.width,height:defulatH*canvas.height});
            previewPath2=allCanvasArr[1].canvas.toDataURL({format: 'png',left:defulatX2*canvas.width,top:defulatY2*canvas.height,width:defulatW*canvas.width,height:defulatH*canvas.height});
        }
    }
    if(productsType=="Planner" || productsType=="Tabletop Display" || productsType=="Placemats" || productsType=="Flyers"){
        setCanvasSize(4,0);
        setCanvasSize(4,1);
        previewPath=allCanvasArr[0].canvas.toDataURL({format: 'png',left:defulatX1*canvas.width,top:defulatY1*canvas.height,width:defulatW*canvas.width,height:defulatH*canvas.height});
        previewPath2=allCanvasArr[1].canvas.toDataURL({format: 'png',left:defulatX2*canvas.width,top:defulatY2*canvas.height,width:defulatW*canvas.width,height:defulatH*canvas.height});
    }
    if(oneOrTwoSide==0 && (productsType=="Tabletop Display" || productsType=="Placemats")){
        previewPath2 =  previewPath;
    }
    canvas.setBackgroundColor("#ffffff");
    if(canvas._objects[0] && canvas._objects[0].isBG)canvas._objects[0].setVisible(true);
    if(canvas.overlayImage)canvas.overlayImage.setVisible(true);
    setCanvasSize(1);
    if(productsType=="Planner" || productsType=="Tabletop Display" || productsType=="Placemats" || productsType=="Flyers"){
        setCanvasSize(1,0);
        setCanvasSize(1,1);
    }
    canvas.renderAll();
    if(productsType=="cup"){
        fabric.Image.fromURL(previewPath,function(img1){
            fabric.filterBackend = new fabric.WebglFilterBackend()
            fabric.filterBackend = fabric.initFilterBackend();
            fabric.Object.prototype.transparentCorners = false;
            let arrCoord;
            if(productSize.indexOf("8")>=0){
                /*arrCoord=[
                    [22,116],[136,123],[268,123],[384,116],
                    [40,263],[137,280],[272,280],[368,261],
                    [57,404],[145,424],[267,424],[351,401],
                    [74,539],[150,552], [258,552],[335,536]
                ]*/
                arrCoord = [
                    [60, 57], [204, 70], [369, 70], [509, 57],
                    [85, 268], [204, 278], [360, 277], [484, 267],
                    [107, 474], [204, 488], [362, 487], [458, 474],
                    [125, 625], [204, 642], [368, 644], [440, 627]
                ]
            }else{
                arrCoord=[
                    [22,114],[136,122],[268,122],[382,112],
                    [44,263],[137,280],[272,280],[361,261],
                    [62,404],[145,424],[267,424],[343,401],
                    [80,539],[150,552], [258,552],[328,539]
                ]
            }
            if(nameType == "plasticpetcups12oz"){
                arrCoord=[
                    [321,547],[414,553],[528,553],[624,541],
                    [330,595],[417,613],[531,613],[618,595],
                    [336,643],[417,667],[528,670],[612,643],
                    [342,685],[417,706], [531,706],[606,691]
                ]
            }
            if(nameType == "plasticpetcups16oz"){
                arrCoord=[
                    [289,445],[396,463],[510,463],[615,442],
                    [297,520],[399,541],[504,541],[606,529],
                    [306,589],[399,607],[507,610],[600,598],
                    [318,685],[402,694], [510,697],[588,679]
                ]
            }
            if(nameType == "plasticppcups"){
                if(productSize.indexOf("17")>=0){
                    arrCoord=[
                        [318,442],[423,460],[531,463],[636,439],
                        [327,523],[423,547],[531,550],[627,529],
                        [333,592],[423,613],[534,616],[621,604],
                        [339,679],[426,691], [531,691],[612,688]
                    ]
                }else{
                    arrCoord=[
                        [327,376],[423,387],[519,387],[615,376],
                        [336,487],[417,508],[516,508],[606,487],
                        [342,577],[417,598],[519,598],[600,580],
                        [351,688],[420,700], [516,700],[591,688]
                    ]
                }
            }
            if(nameType=="bowl"){
                if(productSize.indexOf("12")>=0){
                    arrCoord=[
                        [42, 146], [380, 187], [805, 187], [1111, 140],
                        [56, 355], [380, 398], [805, 400], [1093, 355],
                        [66, 512], [380, 574], [803, 579], [1086, 512],
                        [82, 663], [382, 725], [805, 725], [1066, 663]
                    ]
                }else if(productSize.indexOf("16")>=0){
                    arrCoord=[
                        [49, 106], [235, 130], [540, 130], [750, 95],
                        [69, 210], [235, 240], [543, 237], [734, 210],
                        [82, 315], [231, 343], [545, 347], [712, 315],
                        [98, 413], [238, 451], [545, 451], [698, 413]
                    ]
                }else if(productSize.indexOf("22")>=0){
                    arrCoord=[
                        [43, 74], [269, 94], [527, 94], [764, 75],
                        [62, 235], [271, 260], [532, 263], [745, 232],
                        [77, 418], [271, 447], [527, 449], [734, 407],
                        [93, 561], [246, 600], [527, 604], [716, 563]
                    ]
                }else{
                    arrCoord=[
                        [36, 69], [218, 87], [430, 87], [643, 72],
                        [55, 234], [219, 250], [427, 252], [618, 233],
                        [73, 393], [220, 405], [426, 410], [590, 393],
                        [92, 515], [223, 552], [427, 553], [575, 523]
                    ]
                }
            }
            var filter = new fabric.Image.filters.Warp({
                ovalArc:1,
                coordinates:arrCoord
            });
            if(nameType=="bowl"){
                if(productSize.indexOf("12")>=0){
                    img1.set("scaleX",545/img1.width);
                    img1.set("scaleY",291/img1.height);
                }else if(productSize.indexOf("16")>=0){
                    img1.set("scaleX",700/img1.width);
                    img1.set("scaleY",355/img1.height);
                }else if(productSize.indexOf("22")>=0){
                    img1.set("scaleX",719/img1.width);
                    img1.set("scaleY",531/img1.height);
                }else{
                    img1.set("scaleX",607/img1.width);
                    img1.set("scaleY",490/img1.height);
                }
            }
            /*if(nameType!="bowl" && nameType.indexOf("plastic")<0){
                if(productSize==8){
                    img1.set("scaleX",200/img1.width);
                    img1.set("scaleY",265/img1.height);
                }else{
                    img1.set("scaleX",300/img1.width);
                    img1.set("scaleY",474/img1.height);
                }
            }*/

            img1.filters.push(filter);
            img1.applyFilters();
            $(".paper-handbag-preview .preview-model img:not('.preview-img')").attr("src",img1.toDataURL());
            if(previewPath2){
                fabric.Image.fromURL(previewPath2,function(img2){
                    fabric.filterBackend = new fabric.WebglFilterBackend()
                    fabric.filterBackend = fabric.initFilterBackend();
                    fabric.Object.prototype.transparentCorners = false;
                    var filter = new fabric.Image.filters.Warp({
                        ovalArc:1,
                        coordinates:arrCoord
                    });
                    if(nameType=="bowl"){
                        if(productSize.indexOf("12")>=0){
                            img2.set("scaleX",545/img1.width);
                            img2.set("scaleY",291/img1.height);
                        }else if(productSize.indexOf("16")>=0){
                            img2.set("scaleX",700/img1.width);
                            img2.set("scaleY",355/img1.height);
                        }else if(productSize.indexOf("22")>=0){
                            img2.set("scaleX",719/img1.width);
                            img2.set("scaleY",531/img1.height);
                        }else{
                            img2.set("scaleX",607/img1.width);
                            img2.set("scaleY",490/img1.height);
                        }
                    }
                    /*if(nameType!="bowl" && nameType.indexOf("plastic")<0){
                        if(productSize==8){
                            img2.set("scaleX",200/img2.width);
                            img2.set("scaleY",265/img2.height);
                        }else{
                            img2.set("scaleX",300/img2.width);
                            img2.set("scaleY",474/img2.height);
                        }
                    }*/
                    img2.filters.push(filter);
                    img2.applyFilters();
                    $(".paper-handbag-preview .preview-model .preview-front-model-right").attr("src",img2.toDataURL());
                    updateImg();
                    $(".paper-handbag-preview,.paper-handbag-preview-preview").css('display','block');
                })
            }else{
                updateImg();
                $(".paper-handbag-preview,.paper-handbag-preview-preview").css('display','block');
            }
        });
    }else if(productsType=="bag" || newProduct.indexOf(productsType)>-1){
        $(".paper-handbag-preview .preview-model img:not('.preview-img'):not('.preview-front-coolers')").attr("src",previewPath);
        if(previewPath2){
            $(".paper-handbag-preview .preview-model .preview-front-model-right").attr("src",previewPath2);
        }else {
            if(newProduct.indexOf(productsType)>-1){
                $(".paper-handbag-preview .preview-model .preview-front-model-right").css('display','none');
                if(productsType=="Retractable Banners" || productsType=="Flyers"){
                    $(".paper-handbag-preview-preview .preview-front-model-right").css('display','block');
                }
            }
        }
        if(productsType=="puzzles")$(".paper-handbag-preview .preview-img").css("display","none");
        $(".paper-handbag-preview,.paper-handbag-preview-preview").css('display','block');
        updateImg();
    }else if(productsType=="Planner"){
        $(".paper-handbag-preview .preview-model img:not('.preview-img')").attr("src",previewPath);
        if(previewPath2){
            $(".paper-handbag-preview .preview-model .preview-front-model-right").attr("src",previewPath2);
        }
        $(".paper-handbag-preview,.paper-handbag-preview-preview").css('display','block');
        updateImg();
    }
})
//Close Design Content Preview
$(".paper-handbag-preview .closePreview").on("click",function(params) {
    $(".paper-handbag-preview,.paper-handbag-preview-preview").css('display','none');
})
function findXCoordinate(m, x, y, y2) {
    let b = y - m * x;
    let x2 = (y2 - b) / m;
    return x2;
}

//Canvas adapts according to content
$(".paper-handbag-Diy .uploadPropTipDiyzButtonFit").on("click",function () {
    let that=allCanvasArr[currentNum];
    let canvas=allCanvasArr[currentNum].canvas;
    let canvasRo=canvas.width/that.workAreaWidth;
    //Reserve 2mm distance
    let limitNum=2;
    //Millimeter to pixel conversion
    let limitDistance=canvasRo*limitNum;
    let groupSelection = new fabric.ActiveSelection(canvas._objects, {
        canvas: canvas
    });
    canvas.deactivateAll();
    canvas.setActiveObject(groupSelection);
    //Add 1 millimeter each on both sides
    let newWidth=groupSelection.width+limitDistance*2;
    let newHeight=groupSelection.height+limitDistance*2;
    let inchW=Number((newWidth/canvasRo/25.4).toFixed(1));
    let inchH=Number((newHeight/canvasRo/25.4).toFixed(1));
    if(inchW>that.inchOriginW){
        newWidth=that.inchOriginW*25.4*canvasRo;
    }
    if(inchH>that.inchOriginH){
        newHeight=that.inchOriginH*25.4*canvasRo;
    }
    //Set the position to the left and top
    groupSelection.setLeft(limitDistance);
    groupSelection.setTop(limitDistance);
    that.canFactWidth=newWidth;
    that.canFactHeight=newHeight;
    setCanvasSize(1);
    canvas.deactivateAll();
    canvas.renderAll();
    that.workAreaWidth=newWidth/canvasRo;
    that.workAreaHeight=newHeight/canvasRo;
    that.inchW=Number((newWidth/canvasRo/25.4).toFixed(1));
    that.inchH=Number((newHeight/canvasRo/25.4).toFixed(1));
    if(inchW>that.inchOriginW || inchH>that.inchOriginH){
        let roNormal=newWidth/newHeight;
        let roImg=groupSelection.width/groupSelection.height;
        let imgW=newWidth-limitDistance*2;
        let imgH=imgW/roImg;
        if(roNormal>roImg){
            imgH=newHeight-limitDistance*2;
            imgW=imgH*roImg;
        }
        let scaleX=imgW/ groupSelection.width;
        let scaleY=imgH/ groupSelection.height;
        for(let item of canvas._objects){
            if(item.objType == "text"){
                let newScalWidth = item.width * scaleX;
                let currentFontSize = Number((item.getFontSize() * scaleX).toFixed(1));
                item.scaleX = item.scaleY = 1;
                item.setFontSize(currentFontSize);
                item.setWidth(newScalWidth);
            }else if(item.objType == "image"){
                item.setScaleX(item.scaleX*scaleX);
                item.setScaleY(item.scaleY*scaleY);
            }
        }
        newWidth=imgW+limitDistance*2;
        newHeight=imgH+limitDistance*2;
        that.canFactWidth=newWidth;
        that.canFactHeight=newHeight;
        setCanvasSize(1);
        canvas.deactivateAll();
        canvas.renderAll();
        that.workAreaWidth=newWidth/canvasRo;
        that.workAreaHeight=newHeight/canvasRo;
        that.inchW=Number((newWidth/canvasRo/25.4).toFixed(1));
        that.inchH=Number((newHeight/canvasRo/25.4).toFixed(1));
        //
    }
    setDemension(that.inchW,that.inchH);
    undoArr.unshift(creatDesin());
})

//Adjust the position of the canvas content relative to the canvas----start
let updateContentPosition=function (type) {
    let that=allCanvasArr[currentNum];
    let canvas=allCanvasArr[currentNum].canvas;
    let obj=canvas.getActiveObject();
    let width=defulatW*canvas.width;
    let height=defulatH*canvas.height;
    let left=defulatX*canvas.width;
    let top=defulatY*canvas.height;
    if(oneOrTwoSide==1){
        if(windowHV==1){
            if(obj.getCenterPoint().x<canvas.width/2){
                left=defulatX1*canvas.width;
                top=defulatY1*canvas.height;
            }else {
                left=defulatX2*canvas.width;
                top=defulatY2*canvas.height;
            }
        }else {
            if(obj.getCenterPoint().y<canvas.height/2){
                left=defulatX1*canvas.width;
                top=defulatY1*canvas.height;
            }else {
                left=defulatX2*canvas.width;
                top=defulatY2*canvas.height;
            }
        }
    }
    let canvasWidth = width;
    let canvasHeight = height;
    if(type=="MidL"){
        let objLeft = obj.getLeft();
        let bound = obj.getBoundingRect(true, true);//得到对象的边界
        let limitLeft = left;
        let newLeft = (limitLeft + objLeft - bound.left);
        obj.setLeft(newLeft);
    }else if(type=="MidH"){
        let newLeft = left+(canvasWidth / 2 - (obj.getCenterPoint().x * that.currentSize - obj.left * that.currentSize))
        obj.setLeft(newLeft / that.currentSize);
    }else if(type=="MidR"){
        let objLeft = obj.getLeft();
        let bound = obj.getBoundingRect(true, true);//得到对象的边界
        let limitRight = left+canvasWidth
        let newLeft = (limitRight - bound.width + objLeft - bound.left);
        obj.setLeft(newLeft);
    }else if(type=="MidT"){
        let objTop = obj.getTop();
        let bound = obj.getBoundingRect(true, true);//得到对象的边界
        let limitTop = top;
        let newTop = (limitTop + objTop - bound.top);
        obj.setTop(newTop);
    }else if(type=="MidV"){
        let newTop = top+(canvasHeight / 2 - (obj.getCenterPoint().y * that.currentSize - obj.top * that.currentSize))
        obj.setTop(newTop / that.currentSize);
    }else if(type=="MidB"){
        let objTop = obj.getTop();
        let bound = obj.getBoundingRect(true, true);//得到对象的边界
        let limitBottom = top+canvasHeight;
        let newTop = limitBottom - bound.height + objTop - bound.top
        obj.setTop(newTop);
    }
    obj.setCoords();
    canvas.renderAll();
    deleteBtnSet(true,obj);
    undoArr.unshift(creatDesin());
}
// canvas content to left
$(".editMid .MidL").on("click",function () {
    updateContentPosition("MidL");
})
// Canvas content to h-center
$(".editMid .MidH").on("click",function () {
    updateContentPosition("MidH");
})
// canvas content to right
$(".editMid .MidR").on("click",function () {
    updateContentPosition("MidR");
})
// canvas content to top
$(".editMid .MidT").on("click",function () {
    updateContentPosition("MidT");
})
// Canvas content to v-center
$(".editMid .MidV").on("click",function () {
    updateContentPosition("MidV");
})
// canvas content to bottom
$(".editMid .MidB").on("click",function () {
    updateContentPosition("MidB");
})
//Adjust the position of the canvas content relative to the canvas----end

//Internal alignment of boxed objects-----start
$(".btn-big.btn-align").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    if($(".align-menu").is(":visible")){
        $(".align-menu").css("display","none");
    }else {
        let canvas=allCanvasArr[currentNum].canvas;
        let objActive=canvas.getActiveObject();
        if(!objActive){
            tipShow('Please select at least one objects');
            return;
        }
        $(".align-menu .align-menu-item:not('.align-center,.align-middle')").css("display","none");
        if(objActive._objects){
            $(".align-menu .align-menu-item:not('.align-center,.align-middle')").css("display","flex");
        }
        $(".align-menu").css("display","flex");
    }
})
let updateGroupContent=function (type,addUndo) {
    let that=allCanvasArr[currentNum];
    let canvas=allCanvasArr[currentNum].canvas;
    let objActive=canvas.getActiveObject();
    let objs = objActive._objects;
    if(objActive._objects==undefined){
        return;
    }
    let groupBound = objActive.getBoundingRect(true, false);
    if(type=="alignL"){
        for (let i in objActive.getObjects()) {
            let obj = objActive.getObjects()[i];
            let objBound = getCoord(obj.getLeft(), obj.getTop(), obj.getScaledWidth(), obj.getScaledHeight(), obj.getAngle())
            let offset = objBound.x - (0 - groupBound.width / 2);
            obj.setLeft(obj.left - offset);
            let warnPixObj = obj.warnPixObj;
            if(warnPixObj){
                warnPixObj.setLeft(warnPixObj.left - offset);
            }
        }
    }else if(type=="alignH"){
        for (let i in objActive.getObjects()) {
            let obj = objActive.getObjects()[i];
            let objBound = getCoord(obj.getLeft(), obj.getTop(), obj.getScaledWidth(), obj.getScaledHeight(), obj.getAngle())
            let offset = (0 - objBound.width / 2) - objBound.x;
            obj.setLeft(obj.left + offset);
            let warnPixObj = obj.warnPixObj;
            if(warnPixObj){
                warnPixObj.setLeft(warnPixObj.left + offset);
            }
        }
    }else if(type=="alignR"){
        for (let i in objActive.getObjects()) {
            let obj = objActive.getObjects()[i];
            let objBound = getCoord(obj.getLeft(), obj.getTop(), obj.getScaledWidth(), obj.getScaledHeight(), obj.getAngle())
            let offset = (groupBound.width / 2) - objBound.width - objBound.x;
            obj.setLeft(obj.left + offset);
            let warnPixObj = obj.warnPixObj;
            if(warnPixObj){
                warnPixObj.setLeft(warnPixObj.left + offset);
            }
        }
    }else if(type=="alignT"){
        for (let i in objActive.getObjects()) {
            let obj = objActive.getObjects()[i];
            let objBound = getCoord(obj.getLeft(), obj.getTop(), obj.getScaledWidth(), obj.getScaledHeight(), obj.getAngle())
            let offset = objBound.y - (0 - groupBound.height / 2);
            obj.setTop(obj.top - offset);
            let warnPixObj = obj.warnPixObj;
            if(warnPixObj){
                warnPixObj.setTop(warnPixObj.top - offset);
            }
        }
    }else if(type=="alignV"){
        for (let i in objActive.getObjects()) {
            let obj = objActive.getObjects()[i];
            let objBound = getCoord(obj.getLeft(), obj.getTop(), obj.getScaledWidth(), obj.getScaledHeight(), obj.getAngle())
            let offset = (0 - objBound.height / 2) - objBound.y;
            obj.setTop(obj.top + offset);
            let warnPixObj = obj.warnPixObj;
            if(warnPixObj){
                warnPixObj.setTop(warnPixObj.top + offset);
            }
        }
    }else if(type=="alignB"){
        for (let i in objActive.getObjects()) {
            let obj = objActive.getObjects()[i];
            let objBound = getCoord(obj.getLeft(), obj.getTop(), obj.getScaledWidth(), obj.getScaledHeight(), obj.getAngle())
            let offset = (groupBound.height / 2) - objBound.height - objBound.y;
            obj.setTop(obj.top + offset);
            let warnPixObj = obj.warnPixObj;
            if(warnPixObj){
                warnPixObj.setTop(warnPixObj.top + offset);
            }
        }
    }else if(type=="alignHEven"){
        if (objs.length == 2) return;
        //left from small to large
        objs.sort(function (a, b) {
            if (a.left > b.left) {
                return 1;
            } else if (a.left == b.left) {
                return 0;
            } else if (a.left < b.left) {
                return -1;
            }
        })
        //Calculate object interval
        let spaceSize = groupBound.width;
        for (let i in objs) {
            let objBound = objs[i].getBoundingRect(true, false);
            spaceSize = spaceSize - objBound.width;
        }
        spaceSize = spaceSize / (objs.length - 1);
        //uniform distribution
        let preObjBoundRight;
        for (let i in objs) {
            if (i == 0) {
                preObjBoundRight = groupBound.left;
            } else if (i < (objs.length - 1)) {
                let leftOne = objActive.left + groupBound.width / 2;
                let offset = preObjBoundRight + objs[i - 1].getScaledWidth() + spaceSize;
                objs[i].left = offset - leftOne;
                objs[i].oldXYpoint = null;
                preObjBoundRight = offset;
                let warnPixObj = objs[i].warnPixObj;
                if (warnPixObj) {
                    warnPixObj.setLeft(warnPixObj.left - offset);
                }
            }
        }
    }else if(type=="alignVEven"){
        if (objs.length == 2) return;
        //top from small to large
        objs.sort(function (a, b) {
            let bound1 = a.getBoundingRect(true, false);
            let bound2 = b.getBoundingRect(true, false);
            if (bound1.top > bound2.top) {
                return 1;
            } else if (bound1.top == bound2.top) {
                return 0;
            } else if (bound1.top < bound2.top) {
                return -1;
            }
        })
        //Calculate object interval
        let spaceSize = groupBound.height;
        for (let i in objs) {
            let objBound = objs[i].getBoundingRect(true, false);
            spaceSize = spaceSize - objBound.height;
        }
        spaceSize = spaceSize / (objs.length - 1);
        //uniform distribution
        let preObjBoundBottom;
        for (let i in objs) {
            if (i == 0) {
                let preobjBound = objs[0].getBoundingRect(true, false);
                preObjBoundBottom = preobjBound.top + preobjBound.height;
            } else if (i < (objs.length - 1)) {
                let objBound = objs[i].getBoundingRect(true, false);
                let offset = objBound.top - preObjBoundBottom - spaceSize;
                objs[i].setTop(objs[i].top - offset);
                preObjBoundBottom = objBound.top + objBound.height - offset;
                let warnPixObj = objs[i].warnPixObj;
                if (warnPixObj) {
                    warnPixObj.setTop(warnPixObj.top - offset);
                }
            }
        }
    }
    objActive.addWithUpdate(null);
    objActive.setCoords();
    canvas.renderAll();
    deleteBtnSet(true,objActive);
    if(addUndo)undoArr.unshift(creatDesin());
}
// group content to left
$(".editGroup .alignL").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignL");
})
// group content to h-center
$(".editGroup .alignH").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignH",false);
    updateContentPosition("MidH");
})
// group content to right
$(".editGroup .alignR").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignR");
})
// group content to top
$(".editGroup .alignT").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignT");
})
// group content to v-center
$(".editGroup .alignV").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignV",false);
    updateContentPosition("MidV");
})
// group content to bottom
$(".editGroup .alignB").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignB");
})
// group content to h even
$(".editGroup .alignHEven").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignHEven");
})
// group content to V even
$(".editGroup .alignVEven").on("click",function (event) {
    event.stopPropagation();
    event.preventDefault();
    updateGroupContent("alignVEven");
})
//Internal alignment of boxed objects-----end
/**********other operate end**************/

/**********utils method fun start**************/
function base64ToFile(base64String, fileName) {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
}
//十六进制颜色值的正则表达式
let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
//RGB to 16
let colorHex = function(valueStr){
    if(/^(rgb|RGB)/.test(valueStr)){
        var aColor = valueStr.replace(/(?:\(|\)|rgb|RGB)*/g,"").split(",");
        var strHex = "#";
        for(var i=0;i<aColor.length;i++){
            var hex = Number(aColor[i]).toString(16);
            if(hex === "0"){
                hex += hex;
            }
            if(hex.length<2) hex = "0"+hex;
            strHex += hex;
        }

        if(strHex.length !== 7){
            strHex = valueStr;
        }
        return strHex;
    } else if(reg.test(valueStr)){
        var aNum = valueStr.replace(/#/,"").split("");
        if(aNum.length === 6){
            return valueStr
        }else if(aNum.length === 3){
            var numHex ="#";
            for(var i=0;i<aNum.length;i+=1){
                numHex += (aNum[i]+aNum[i]);
            }
            return numHex
        }
    }else{
        return valueStr
    }
}
//16 to ten
let colorDecimal = function(valueStr){
    //console.log(valueStr);
    var colorValue
    //如果含有#，则去掉，再转换
    if(valueStr.indexOf('#')!=-1){
        var arr = valueStr.split("#")
        var str = arr[1];
        colorValue = parseInt(str,16);
    }
    else
    {
        colorValue = parseInt(str,16);
    }
    return colorValue

}
/**********utils method fun end**************/
let getCoord = function (x, y, w, h, r) {
    var t_x = 0;
    var t_y = 0;
    var t_w = 0;
    var t_h = 0;
    if (r == 0 || r == 360) {
        r = 0
    } else {
        while(r < 0) {
            r += 360;
        }
        if (r > 180) r = r - 360;
        if (r > 180) r = r - 360;
    }
    var sin_r; //= Math.sin(r*Math.PI/180);
    var cos_r; //= Math.cos(r*Math.PI/180);
    if (r >= 0 && r <= 90) {
        sin_r = Math.sin(r * Math.PI / 180);
        t_x = x - h * sin_r;
        t_y = y;
        //计算旋转后的宽高
        if (r == 0) {
            t_w = w;
            t_h = h;
        } else {
            t_w = h * sin_r + w * Math.cos(r * Math.PI / 180);
            t_h = w * sin_r + h * Math.cos(r * Math.PI / 180);
        }
    } else if (r > 90 && r <= 180) {
        sin_r = Math.sin((r - 90) * Math.PI / 180);
        cos_r = Math.cos((r - 90) * Math.PI / 180);
        t_y = y - h * sin_r;
        t_x = x - h * cos_r - w * sin_r;
        //计算旋转后的宽高
        if (r == 180) {
            t_w = w;
            t_h = h;
        } else {
            t_w = h * cos_r + w * sin_r;
            t_h = w * cos_r + h * sin_r;
        }
    } else if (r >= -90 && r <= 0) {
        sin_r = Math.sin((-r) * Math.PI / 180);
        t_x = x;
        t_y = y - w * sin_r;
        //计算旋转后的角度
        cos_r = Math.cos((-r) * Math.PI / 180)
        t_w = h * sin_r + w * cos_r;
        t_h = w * sin_r + h * cos_r;
    } else if (r >= -180 && r < -90) {
        sin_r = Math.sin((-(r + 90)) * Math.PI / 180);
        cos_r = Math.cos((-(r + 90)) * Math.PI / 180);
        t_x = x - w * sin_r;
        t_y = y - w * cos_r - h * sin_r;
        //计算旋转后的角度
        if (r == 180) {
            t_w = w;
            t_h = h;
        } else {
            t_w = w * sin_r + h * cos_r;
            t_h = w * cos_r + h * sin_r;
        }
    }
    var coord = {
        'x': t_x,//Math.round(t_x)
        'y': t_y,//Math.round(t_y)
        'width': t_w,
        'height': t_h
    };
    return coord;
}
let createProduct=function () {
    let publicInit=JSON.stringify({"media":{"mediaType":"shape","isBG":false,},"visible":true,"printLocation":{"rotation":0,"x":0,"width":600,"y":0,"height":365},"location":{"factWidth":10000,"factHeight":10000,"rotation":0,"x":0,"width":600,"y":0,"height":365}});
    let curentProduct={"pageList":[]};
    for(let i=0; i<allCanvasArr.length;i++){
        let that=allCanvasArr[i];
        let canvas=that.canvas;
        let pageItem={};
        pageItem.content={};
        pageItem.content.itemList=[];
        pageItem.diyWorkAreaWidth=canvas.width;
        pageItem.diyWorkAreaHeight=canvas.height;
        pageItem.workAreaWidth=that.workAreaWidth;
        pageItem.workAreaHeight=that.workAreaHeight;
        pageItem.pageOrder=(i+1);
        for(let item of canvas._objects){
            if(item.objType!="guideLine"){
                let publicProper=JSON.parse(publicInit);
                publicProper.location.x=item.left
                publicProper.location.y=item.top
                publicProper.location.width=item.getScaledWidth();
                publicProper.location.height=item.getScaledHeight();
                let angle=item.getAngle();
                publicProper.location.rotation=angle;
                let coord = getCoord(item.left, item.top, item.getScaledWidth(), item.getScaledHeight(), item.getAngle());
                publicProper.printLocation.x=coord.x;
                publicProper.printLocation.y=coord.y;
                publicProper.printLocation.width=coord.width;
                publicProper.printLocation.height=coord.height;
                publicProper.printLocation.rotation=angle;
                if(item.objType=="text"){
                    if(item.textLines != "" && item.textLines != "click on me to modify"){
                        publicProper.media.lineSpace=1.16;
                        publicProper.media.mediaType="text";
                        publicProper.media.text=item.textLines.join("\n");
                        publicProper.media.charSpace="0",
                        publicProper.media.font={
                            "pointSize": item.fontSize,
                            "gravity": item.textAlign,
                            "id": $(".font-select .selectDrop li[fontname="+item.fontFamily+"]").attr("fontid"),
                            "fontColor": item.fill
                        }
                        let textitem = JSON.parse(JSON.stringify(publicProper.media.font));
                        textitem.text = item.textLines.join("\n");
                        textitem.fontFamily=item.fontFamily;
                        textInfo.push(textitem);
                    }else{
                        continue;
                    }
                }else if(item.objType=="image"){
                    let canvasImg = item.getSrc();
                    if (canvasImg.indexOf("!") != -1) {
                        canvasImg = canvasImg.split("!")[0];
                    } else {
                        canvasImg = canvasImg.replace("large", "normal");
                    }
                    publicProper.media.mediaType="image";
                    publicProper.media.imgPath=canvasImg;
                    publicProper.location.factWidth=item.factWidth;
                    publicProper.location.factHeight=item.factHeight;
                }else if(item.objType=="shape"){
                    publicProper.media.isBG=true;
                    publicProper.media.color=colorDecimal(colorHex(item.fill));
                }
                pageItem.content.itemList.push(publicProper);
            }
        }
        curentProduct.pageList.push(pageItem);
    }
    if(oneOrTwoSide==0 && (productsType=="Tabletop Display" || productsType=="Placemats")){
        curentProduct.pageList[1] =  curentProduct.pageList[0];
    }
    return JSON.parse(JSON.stringify(curentProduct));
}

//Generate preview images and notify other operations
function ContinueFunzCupsNew(){
    textInfo = [];
    let canvas=allCanvasArr[currentNum].canvas;
    updateGuideLineShow(false);
    var istrue=false;
    newCupsIdListFile=[];
    newCupsIdListFileList=[];
    $('.cartreloads').find('p').text('Create file...');
    $('.cartreloads').css('display','block');
    if(fileUserIdA==undefined && fileUserIdB==undefined){
        for(let i = 0;i<allCanvasArr.length;i++){
            if(allCanvasArr[i].canvas){
                for (let item of allCanvasArr[i].canvas._objects){
                    if(item.objType=="image" && !item.isBG){
                        newCupsIdListFile.push(item.uniqueid);
                        newCupsIdListFileList.push(item.getSrc());
                    }
                    if(item.objType=="text" && item.textLines == "click on me to modify"){
                        item.visible = false;
                        allCanvasArr[i].canvas.renderAll();
                    }
                }
            }
        }
        if(newCupsIdListFile.length>0){
            productVarId=newCupsIdListFile[0]
            $(".uploadImgid").val(newCupsIdListFile[0]);
        }
        setCanvasSize(3);
        let resultImg=canvas.toDataURL({format: 'png'});
        setCanvasSize(1);
        let file = base64ToFile(resultImg,"1.png");
        let formData = new FormData();
        formData.append("file", file);
        $.ajax({
            url: locaUploadzlg,
            type: "post",
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            async:false,
            success: (res) => {
                if(res.result == "true"){
                    let imgPath=res.path;
                    // $('.uploadImgidrema').val($('.uploadProp3TextareaDiy').val())
                    $('.designUpload').attr('src',imgPath);
                    if(newProduct.indexOf(productsType)>-1 || productsType=="Planner"){//new product pdf
                        let product = createProduct();
                        product.uniqueId=res.id;
                        console.log("uniqueId=="+res.id);
                        newCupsIdListFile.push(res.id);
                        newCupsIdListFileList.push(imgPath);
                        productVarId=res.id
                        $(".uploadImgid").val(res.id);
                        $.ajax({
                            //url: window.locaUrlDiy +'/diyWeb/commontool/addImageToPdf.do',
                            // url: "https://diy.36588.com.cn/diyWeb/csrdiy/addItemsToPdf_hwz.do",
                            url: window.locaUrlDiy + "/diyWeb/csrdiy/addItemsToPdf_hwzByGuonei.do",
                            method: 'post',
                            dataType: "json",
                            contentType: 'application/json',
                            data: JSON.stringify(product),
                            async:false,
                            success: function (result) {
                                if (result.success && result.userData=="1") {
                                    $('.cartreloads').find('p').text('Add to cart...');
                                    productVarId=product.uniqueId
                                    $(".uploadImgid").val(product.uniqueId);
                                    $('.cartreloads').css('display','none');
                                    $('#createDesignPreviewImg').css('pointer-events', 'initial');
                                    isContinueFunz=true
                                    istrue=ContinueFunzBig(2)
                                } else {
                                    $('.cartreloads').css('display','none');
                                    tipShow('Failed to add shopping cart. Please refresh the page and try again');
                                }
                            }, error: function () {
                                $('.cartreloads').css('display','none');
                                tipShow('Failed to add shopping cart. Please refresh the page and try again');
                            }
                        });
                    }else {
                        appendTextInfo();
                        $('.cartreloads').find('p').text('Add to cart...');
                        productVarId=res.id
                        $(".uploadImgid").val(res.id);
                        newCupsIdListFile.push(res.id);
                        newCupsIdListFileList.push(imgPath);
                        if(productsType=="cup"){
                            // paperCupId = $('.bg-list-items .active').length > 0 ? $('.bg-list-items .active').attr('bgtemplateid') : '';
                            templateType = 'paperCup';
                            templateId = $('.bg-list-items .active').length > 0 ? $('.bg-list-items .active').attr('bgtemplateid') : '';
                        }
                        $('.cartreloads').css('display','none');
                        $('#createDesignPreviewImg').css('pointer-events', 'initial');
                        isContinueFunz=true
                        istrue=ContinueFunzBig(2)
                    }
                }else{
                    $('.cartreloads').css('display','none');
                    tipShow('Failed to add shopping cart. Please refresh the page and try again');
                }
            },
            error:function(err){
                $('.cartreloads').css('display','none');
                console.log(err)

            }
        });
    }else {
        $('.cartreloads').find('p').text('Add to cart...');
        if(fileUserIdA){
            newCupsIdListFile.push(fileUserIdA.split("&&")[0]);
            newCupsIdListFileList.push(fileUserIdA.split("&&")[1]);
        }
        if(fileUserIdB){
            newCupsIdListFile.push(fileUserIdB.split("&&")[0]);
            newCupsIdListFileList.push(fileUserIdB.split("&&")[1]);
        }
        isContinueFunz=true
        istrue=ContinueFunzBig(2);
    }
    return istrue
}

var appendTextInfo = function(){
    for(let i=0; i<allCanvasArr.length;i++){
        let that=allCanvasArr[i];
        let canvas=that.canvas;
        for(let item of canvas._objects){
            if(item.objType!="guideLine"){
                if(item.objType=="text"){
                    if(item.textLines != "" && item.textLines != "click on me to modify"){
                        var textitem = {};
                        textitem.text=item.textLines.join("\n");
                        textitem.pointSize=item.fontSize;
                        textitem.fontFamily=item.fontFamily;
                        textitem.id=$(".font-select .selectDrop li[fontname="+item.fontFamily+"]").attr("fontid");
                        textitem.fontColor=item.fill
                        textInfo.push(textitem);
                    }
                }
            }
        }
    }
    console.log(textInfo);
}
